<template>
  <div class="ml-6 mr-6 mt-4"> <!--note: mt,mb,ml,mr(margin) jangan diubah-->
    <v-layout row wrap>
      <v-flex
        sm6
        xs12
        md6
        lg12
        >
        <v-card height="auto" class="mb-6 rounded-lg" flat>
          <v-card-title height="50" class="body-2 font-weight-regular blue-grey lighten-5 grey--text">
            <v-icon small class="mr-4" color="grey">mdi-laptop</v-icon> Analytical Overview > Most Talked
          </v-card-title>
          
          <v-alert class="mb-3" v-if="alert" border="top" :color="colorAlert" dark>
                {{ message }}
              </v-alert>
           <!-- TOPIC BERITA DAN PEROIDE BERITA -->
            <v-row class="mt-4 ml-2">
              <v-col class="d-flex" cols="12" sm="2">
                <v-select class=" elevation-0 shadow-0" dense
                  :items="topicsentiment"
                  outlined rounded
                  label="Topic"
                  v-model="selectedTopic"
                  @change="isPerson = true, isOrganisasi = false, loadKontenBerita()"
                  >
                </v-select>
              </v-col>
              <v-col class="d-flex" cols="12" sm="2">
                <v-select dense class="elevation-0 shadow-0"
                  :items="periodeberita"
                  outlined rounded
                  label="Periode Berita"
                  v-model="selectedPeriode"
                  @change="isPerson = true, isOrganisasi = false, loadKontenBerita()"
                  >
                  <template v-slot:append-item>
                    <v-list-item>
                      <v-list-item-title>
                        <v-menu
                          v-model="menu"
                          :close-on-content-click="false"
                          :nudge-width="200"
                          offset-x
                          >
                          <template v-slot:activator="{ on, attrs }">
                            <v-btn small width="120"
                              color="#0471A5"
                              dark
                              v-bind="attrs"
                              v-on="on"
                              >
                              Custom
                            </v-btn>
                          </template>
                          <v-card>
                            <v-row justify="space-around" class="ma-4">
                              <v-date-picker dense
                                v-model="date1"
                                :show-current="false"
                                color="#0471A5">
                              </v-date-picker>
                              <v-date-picker class="ml-8"
                                v-model="date2"
                                show-current="2013-07-13"
                                color="#0471A5"
                                header-color="#0471A5">
                              </v-date-picker>
                            </v-row>
                            <v-card-actions>
                              <v-spacer></v-spacer>
                              <v-btn
                                text
                                @click="menu = false"
                                >
                                Cancel
                              </v-btn>
                              <v-btn
                                color="primary"
                                text
                                @click="loadKontenBerita"
                                >
                                Set
                              </v-btn>
                            </v-card-actions>
                          </v-card>
                        </v-menu>
                      </v-list-item-title>
                    </v-list-item>
                  </template>
                </v-select>
              </v-col>
              <v-col class="d-flex mt-3 ma-0 pa-0 mx-3" cols="12" sm="2">
                <v-select class="elevation-0 shadow-0" dense background-color="#0471A5" dark
                  :items="topicsentiment"
                  v-model="selectedTopic2"
                  outlined rounded
                  label="select"
                  
                  @change="isPerson = true, isOrganisasi = false, loadKontenBerita()"
                  >
                </v-select>
              </v-col>
            </v-row>
            <!--END TOPIC DAN PEROIDE BERITA-->     
            <v-row>
            <v-flex lg8>
              <div class="example ml-4 mb-4"> 
                <v-card-text>Sentiment Analysis</v-card-text>
                  <apexcharts class="" width="100%" height="240px" type="line" :options="sentimentanalysis" :series="seriessentiment"></apexcharts>
              </div>
              <div align="center" justify="center">
                      <v-row class="mx-4 mb-4" align="center" justify="center">
                        <v-flex
                          xs12
                          sm12
                          md12
                          lg4
                          >
                            <v-btn color="#fff" x-large width="220px" height="80" class=" mx-3 my-3"  style="color: #0471A5;border-radius: 8px;box-shadow: rgba(0, 0, 0, 0.05) 0px 6px 24px 0px, rgba(0, 0, 0, 0.08) 0px 0px 0px 1px;"  @click="loadSentimentanalysisBerita">
                              <v-card-text>
                                <h2 align="center" justify="center" class="text--teal darken-2">
                                  <v-avatar class="color-avatar4" size="36">
                                          <v-icon class="white--text">mdi-web</v-icon>
                                  </v-avatar>  
                                  {{valueTotalBerita}}
                                </h2>
                                <h5 align="center" justify="center" class="text--teal darken-2">Total Berita Online</h5>
                              </v-card-text>
                            </v-btn>
                          </v-flex>

                          <v-flex
                            xs12
                            sm12
                            md12
                            lg4
                            >
                            <v-btn color="#fff" x-large width="220px" height="80" class=" mx-3 my-3" style="color: #0471A5;border-radius: 8px; box-shadow: rgba(0, 0, 0, 0.05) 0px 6px 24px 0px, rgba(0, 0, 0, 0.08) 0px 0px 0px 1px;" @click="loadSentimentTweet">
                              <v-card-text>
                                <h2 align="center" justify="center" class="text--teal darken-2">
                                  <v-avatar class="color-avatar3" size="36">
                                          <v-icon class="white--text">mdi-twitter</v-icon>
                                  </v-avatar>
                                  {{valueTotalTwet}}
                                </h2>
                                <h5 align="center" justify="center"  class="text--teal darken-2">Total Tweet</h5>
                              </v-card-text>
                            </v-btn>
                          </v-flex>
                          <v-flex
                            xs12
                            sm12
                            md12
                            lg4
                            >
                            <v-btn color="#fff" x-large width="220px" height="80" class=" mx-3 my-3"  style="color: #0471A5;
                            border-radius: 8px; 
                            box-shadow: rgba(0, 0, 0, 0.05) 0px 6px 24px 0px, rgba(0, 0, 0, 0.08) 0px 0px 0px 1px;"
                             @click="loadSentimentYt">
                              <v-card-text>
                                <h2 align="center" justify="center" class="text--teal darken-2 my-2">
                                  <v-avatar class="color-avatar2" size="36">
                                          <v-icon class="white--text">mdi-youtube</v-icon>
                                  </v-avatar>
                                  {{valueTotalYt}}
                                </h2>
                                <h5 align="center" justify="center" class="text--teal darken-2 my-2">Total Comment Youtube</h5>
                              </v-card-text>
                            </v-btn>
                        </v-flex>
                      </v-row>
                    </div>
            </v-flex>

             <v-flex lg4>
              <v-card flat max-width="400px" height="auto"> 
                <v-card-text class="mt-4">
                  <apexchart type="donut" :options="chartOptionss" :series="seriess"></apexchart>
                </v-card-text>
              </v-card>
            </v-flex>
          </v-row>
        </v-card>
      </v-flex>
      
      <v-flex sm6 xs12 md6 lg6>
      <v-card height="610px" class="mt-4 mr-4 mb-6 rounded-lg" flat>
        <v-card-text class="text-md-body-1">Influencing</v-card-text>
        <v-container fill-height fluid>
          <v-row align="center" justify="center">
            <v-col><Toppersonbubble ref="topPersonComponent" :selectedTopic2="selectedTopic2" :selectedTopic="selectedTopic" :selectedPeriode="selectedPeriode"></Toppersonbubble></v-col>
          </v-row>
        </v-container>
      </v-card>
    </v-flex>

    <v-flex sm6 xs12 md6 lg6>
      <v-card height="300px" width="100%" class="mt-4 mr-4 mb-6 rounded-lg justify-center align-center" flat>
        <v-card-text class="text-md-body-1">Influenced Topics</v-card-text>
          <div width="100%" class="mr-16 align-center justify-center" align="center" justify="center">
            <vue-word-cloud class="ml-10" width="100%" align="center" justify="center"
              style="height: 200px;"
              :words="words"
              :color="([, weight]) => weight > 10 ? '#0471A5' : weight > 5 ? '#0471A5' : '#0471A5'"
              font-family="Roboto"
            />
          </div>
        </v-card>
        <v-card height="300px" class="mt-4 mb-6 rounded-lg" flat>
          <v-row class="ma-0 pa-0">
            <v-card-text class="ml-4">
              <v-btn class="mt-2 mb-4 elevation-0" small rounded
                color="#0471A5"
                dark
                >
                Person
              </v-btn>
                <v-btn class="mt-2 mb-4 elevation-0 ml-2" small rounded outlined
                color="#0471A5"
                dark
                >
                Organization 
              </v-btn>
            </v-card-text>
          </v-row>
          <apexchart type="bar" height="200" :options="barchart" :series="series1"  @click="clickChartBar"></apexchart>
        </v-card>
      </v-flex>
    
    
      <v-flex sm12 xs12 md12 lg12>
        <v-card height="600px" class="mt-4 mr-4 mb-6 rounded-lg" flat>
          <v-flex lg12>
            <v-row class="pa-4">
              <v-flex lg8 md8>
                <v-card-text class="text-md-body-1">
                  Konten Berita
                </v-card-text>
              </v-flex>
              <v-flex lg4 md4>
                <v-card-text class="d-flex align-end flex-column">
                  <div>
                    <v-btn small class="mr-4" outlined color="#0471A5">
                      Capture
                    </v-btn>
                  </div>
                </v-card-text>
              </v-flex>
            </v-row>
            <v-row class="ma-4">
              <v-flex xs12 sm12 md12 lg12>
                <v-tabs color="#0471A5" class="mr-4">
                  <v-tab class="tab">Netral 
                    <v-chip small class="ma-2" color="#0471A5" text-color="white">
                      {{beritaNetralPersen}} %
                    </v-chip>
                  </v-tab>
                  <v-tab-item>
                    <v-card width="100%" height="450px" class="overflow-card" flat>
                      <v-row class="mx-2 my-4">
                        <!--card-->
                          <v-flex xs12 sm12 md12 lg12 
                          v-for="item in kontenBeritaNetral" :key="item.id">
                          <v-hover v-slot="{ hover }" close-delay="200">
                            <v-card :href="item.url" target="_blank" flat class="mb-4 rounded-lg" :elevation="hover ? 8 : 0" :class="{ 'on-hover': hover }">
                              <div class="d-flex flex-no-wrap justify-space-between">
                                <div>
                                  <v-list-item three-line class="pt-4">
                                    <v-list-item-content>
                                      <v-flex lg10> <v-list-item-title class="body-1 mb-1 primary--text" :href="item.url"
                                target="_blank">{{item.title}}</v-list-item-title></v-flex>
                                      <v-list-item-subtitle>{{item.url}}</v-list-item-subtitle>
                                      <v-list-item-subtitle>{{item.content}}</v-list-item-subtitle>
                                    </v-list-item-content>
                                  </v-list-item>
                                </div>
                              </div>
                            </v-card>
                          </v-hover>
                        </v-flex>
                        <!--end card-->                         
                        </v-row>
                      </v-card>
                    </v-tab-item>

                    <v-tab class="tab">Negatif 
                      <v-chip small class="ma-2" color="#0471A5" text-color="white">{{beritaNegativePersen}} %</v-chip>
                    </v-tab>

                    <v-tab-item>
                    <v-card width="100%" height="450px" class="overflow-card" flat>
                      <v-row class="mx-2 my-4">
                        <!--card-->
                          <v-flex xs12 sm12 md12 lg12 
                            v-for="item in kontenBeritaNegative" :key="item.id">
                            <v-hover v-slot="{ hover }" close-delay="200">
                              <v-card :href="item.url" target="_blank" flat class="mb-2 rounded-lg" :elevation="hover ? 8 : 0" :class="{ 'on-hover': hover }">
                                <div class="d-flex flex-no-wrap justify-space-between">
                                  <div>
                                    <v-list-item three-line class="pt-4">
                                      <v-list-item-content>
                                        <v-flex lg10> <v-list-item-title class="body-1 mb-1 primary--text" :href="item.url"
                                  target="_blank">{{item.title}}</v-list-item-title></v-flex>
                                        <v-list-item-subtitle>{{item.url}}</v-list-item-subtitle>
                                        <v-list-item-subtitle>{{item.content}}</v-list-item-subtitle>
                                      </v-list-item-content>
                                    </v-list-item>
                                  </div>
                                </div>
                              </v-card>
                            </v-hover>
                          </v-flex>
                        <!--end card-->                       
                        </v-row>
                      </v-card>
                    </v-tab-item>

                    <v-tab class="tab">Positif 
                      <v-chip small class="ma-2" color="#1A8EC5" text-color="white">
                        {{beritaPositifPersen}} %
                      </v-chip>
                    </v-tab>
                    <v-tab-item>
                    <v-card width="100%" height="450px" class="overflow-card" flat>
                      <v-row class="mx-2 my-4">
                        <!--card-->
                          <v-flex xs12 sm12 md12 lg12  v-for="item in kontenBeritaPositive" :key="item.id">
                              <v-hover v-slot="{ hover }" close-delay="200">
                                <v-card :href="item.url" target="_blank" flat class="mb-2 rounded-lg" :elevation="hover ? 8 : 0" :class="{ 'on-hover': hover }">
                                  <div class="d-flex flex-no-wrap justify-space-between">
                                    <div>
                                      <v-list-item three-line class="pt-4">
                                        <v-list-item-content>
                                          <v-flex lg10> <v-list-item-title class="body-1 mb-1 primary--text" :href="item.url"
                                    target="_blank">{{item.title}}</v-list-item-title></v-flex>
                                          <v-list-item-subtitle>{{item.url}}</v-list-item-subtitle>
                                          <v-list-item-subtitle>{{item.content}}</v-list-item-subtitle>
                                        </v-list-item-content>
                                      </v-list-item>
                                    </div>
                                  </div>
                                </v-card>
                              </v-hover>
                            </v-flex>
                        <!--end card-->                      
                        </v-row>
                      </v-card>
                    </v-tab-item>
                  </v-tabs>
                </v-flex>   
              </v-row>
            </v-flex>
            </v-card>
        </v-flex>
      <v-dialog v-model="dialog" persistent max-width="290">                 
        <v-card>
          <v-card-title class="text-h6 font-weight-medium align-center justify-center">
            Page loading
          </v-card-title>
          <v-card-text class="body-1 align-center justify-center"> Loading content, please wait</v-card-text>
            <v-card-title class="align-center justify-center">
              <v-progress-circular :size="70" :width="7" color="#0471A5" indeterminate></v-progress-circular>
            </v-card-title>
          <v-card-actions>
          <v-spacer></v-spacer>
            <v-btn color="#0471A5" text @click="dialog = false">
              cancel
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <div>
        <Notification  ref="alert"></Notification>
      </div>
    </v-layout>
  </div>
</template>


<script>
import { hierarchy, pack } from 'd3-hierarchy';
import VueApexCharts from 'vue-apexcharts'
import VueWordCloud from 'vuewordcloud';
import Toppersonbubble from '@/components/Toppersonbubble';
import Notification from  '@/components/Notification';
import axios from "axios"

export default {
  components: {
    Toppersonbubble: Toppersonbubble,
    apexcharts: VueApexCharts,
    [VueWordCloud.name]: VueWordCloud,
    Notification: Notification
  },
  data: function() {
    return {
      Settanggal : [],
      StartDateLast30: "",
      EndDate: "",
      SetPerson: [],
      SetOrganisasi: [],
      words:[],
      SetWord: [],
      selectedTopic: "",
      selectedTopic2: "",
      
      selectedPeriode: "Last 7 Days",
      topicsentiment: [],
      periodeberita: ['Today', 'Yesterday', 'Last 7 Days', 'Previous Week', 'Last 30 Days', 'Previous Month'],
      dialog: false,
      isPerson: false,
      isOrganisasi: false,          
      click: "", 
      
      beritaNetralPersen : "",
      beritaNegativePersen: "",
      beritaPositifPersen : "",
      kontenBerita: [],  

      dialoginfoError:false,
      alert: false,
      colorAlert: "",
      message : "",

      
      mediaBeritaNew: [],// new
      MediatwitterShareNew: [],// new
      MediaYtShareNew: [],// new
      chartTweet: [],// new
      chartNews: [],// new
      chartCombinasi: [],// new
      valueTotalBerita : "",// new
      valueTotalTwet: "",// new
      valueTotalYt: "",// new



      wordCloudIndx0: [],
      wordCloudIndx1: [],
      wordCloudIndx2: [],
      wordCloudIndx3: [],
      wordCloudIndx4: [], 
                   
      chartBubleIndx0:[],
      chartBubleIndx1: [],
      chartBubleIndx2: [],
      chartBubleIndx3: [],
      chartBubleIndx4: [],
      chartBubleIndx5: [], 
      chartBubleIndx0Org: [],
      chartBubleIndx1Org: [],
      chartBubleIndx2Org: [],
      chartBubleIndx3Org: [],
      chartBubleIndx4Org: [],
      chartBubleIndx5Org: [], 
              
      // klik button jumlah       
      kontenBeritaPositive: [],//all kontent per sentiment
      kontenBeritaNegative: [],//all kontent per sentiment
      kontenBeritaNetral: [],//all kontent per sentiment

      mediaBerita: [],
      MediatwitterShare: [],
      MediaYtShare: [], 
      mediaBeritaPositive: [],       
      mediaBeritaNegative: [],       
      mediaBeritaNetral: [],
      count_chart_mediaBeritaPositive: "",       
      count_chart_mediaBeritaNegative: "",       
      count_chart_mediaBeritaNetral: "", 
      kontenTwitterPositive: [],
      kontenTwitterNegative: [],
      kontenTwitterNetral: [],
      count_chart_kontenTwitterPositive: "",
      count_chart_kontenTwitterNegative: "",
      count_chart_kontenTwitterNetral: "",
      kontenYoutubePositive: [],
      kontenYoutubeNegative: [],
      kontenYoutubeNetral: [], 
      count_chart_kontenYoutubePositive: "",
      count_chart_kontenYoutubeNegative: "",
      count_chart_kontenYoutubeNetral: "", 
      

      // =============================== and no delete 
      // =============================== and no delete 
      // =============================== and no delete  

// =================no pakai 
      // ===============????
      wordCloudIndx0Berita: [],
      wordCloudIndx1Berita: [],
      wordCloudIndx2Berita: [],
      wordCloudIndx3Berita: [],
      wordCloudIndx4Berita: [],        
      wordCloudIndx0Twitter: [],
      wordCloudIndx1Twitter: [],
      wordCloudIndx2Twitter: [],
      wordCloudIndx3Twitter: [],
      wordCloudIndx4Twitter: [],        
      wordCloudIndx0Youtube: [],
      wordCloudIndx1Youtube: [],
      wordCloudIndx2Youtube: [],
      wordCloudIndx3Youtube: [],
      wordCloudIndx4Youtube: [],
      // no delete                                   
      valueBubleIndx0Berita: [],
      valueBubleIndx1Berita: [],
      valueBubleIndx2Berita: [],
      valueBubleIndx3Berita: [],
      valueBubleIndx4Berita: [],
      valueBubleIndx5Berita: [],
      valueBubleIndx0Twitter: [],
      valueBubleIndx1Twitter: [],
      valueBubleIndx2Twitter: [],
      valueBubleIndx3Twitter: [],
      valueBubleIndx4Twitter: [],
      valueBubleIndx5Twitter: [],
      valueBubleIndx0Youtube: [],
      valueBubleIndx1Youtube: [],
      valueBubleIndx2Youtube: [],
      valueBubleIndx3Youtube: [],
      valueBubleIndx4Youtube: [],
      valueBubleIndx5Youtube: [],
      // end no delete                                   

      valueBubleIndx0OrgBerita: [],
      valueBubleIndx1OrgBerita: [],
      valueBubleIndx2OrgBerita: [],
      valueBubleIndx3OrgBerita: [],
      valueBubleIndx4OrgBerita: [],
      valueBubleIndx5OrgBerita: [],
      valueBubleIndx0OrgTwitter: [],
      valueBubleIndx1OrgTwitter: [],
      valueBubleIndx2OrgTwitter: [],
      valueBubleIndx3OrgTwitter: [],     
      valueBubleIndx4OrgTwitter: [],
      valueBubleIndx5OrgTwitter: [],     
      valueBubleIndx0OrgYoutube: [],
      valueBubleIndx1OrgYoutube: [],
      valueBubleIndx2OrgYoutube: [],
      valueBubleIndx3OrgYoutube: [],
      valueBubleIndx4OrgYoutube: [],
      valueBubleIndx5OrgYoutube: [],  
      // klik buble
      wordCloudIndx0Person0: [],
      wordCloudIndx1Person0: [],
      wordCloudIndx2Person0: [],
      wordCloudIndx3Person0: [],
      wordCloudIndx4Person0: [],
      wordCloudIndx0Person1: [],
      wordCloudIndx1Person1: [],
      wordCloudIndx2Person1: [],
      wordCloudIndx3Person1: [],
      wordCloudIndx4Person1: [],
      wordCloudIndx0Person2: [],
      wordCloudIndx1Person2: [],
      wordCloudIndx2Person2: [],
      wordCloudIndx3Person2: [],
      wordCloudIndx4Person2: [],
      wordCloudIndx0Person3: [],
      wordCloudIndx1Person3: [],
      wordCloudIndx2Person3: [],
      wordCloudIndx3Person3: [],
      wordCloudIndx4Person3: [],
      wordCloudIndx0Person4: [],
      wordCloudIndx1Person4: [],
      wordCloudIndx2Person4: [],
      wordCloudIndx3Person4: [],
      wordCloudIndx4Person4: [],
      wordCloudIndx0Person5: [],
      wordCloudIndx1Person5: [],
      wordCloudIndx2Person5: [],
      wordCloudIndx3Person5: [],
      wordCloudIndx4Person5: [],
      valueBublePerson0Indx0: [],
      valueBublePerson0Indx1: [],
      valueBublePerson0Indx2: [],    
      valueBublePerson0Indx3: [],
      valueBublePerson0Indx4: [],    
      valueBublePerson0Indx5: [], 
      valueBubleOrg0Indx0: [],
      valueBubleOrg0Indx1: [],
      valueBubleOrg0Indx2: [],    
      valueBubleOrg0Indx3: [],
      valueBubleOrg0Indx4: [],    
      valueBubleOrg0Indx5: [],       
      valueBublePerson1Indx0: [],
      valueBublePerson1Indx1: [],
      valueBublePerson1Indx2: [],    
      valueBublePerson1Indx3: [],
      valueBublePerson1Indx4: [],    
      valueBublePerson1Indx5: [], 
      valueBubleOrg1Indx0: [],
      valueBubleOrg1Indx1: [],
      valueBubleOrg1Indx2: [],    
      valueBubleOrg1Indx3: [],
      valueBubleOrg1Indx4: [],    
      valueBubleOrg1Indx5: [],       
      valueBublePerson2Indx0: [],
      valueBublePerson2Indx1: [],
      valueBublePerson2Indx2: [],    
      valueBublePerson2Indx3: [],
      valueBublePerson2Indx4: [],    
      valueBublePerson2Indx5: [], 
      valueBubleOrg2Indx0: [],
      valueBubleOrg2Indx1: [],
      valueBubleOrg2Indx2: [],    
      valueBubleOrg2Indx3: [],
      valueBubleOrg2Indx4: [],    
      valueBubleOrg2Indx5: [],       
      valueBublePerson3Indx0: [],
      valueBublePerson3Indx1: [],
      valueBublePerson3Indx2: [],    
      valueBublePerson3Indx3: [],
      valueBublePerson3Indx4: [],    
      valueBublePerson3Indx5: [], 
      valueBubleOrg3Indx0: [],
      valueBubleOrg3Indx1: [],
      valueBubleOrg3Indx2: [],    
      valueBubleOrg3Indx3: [],
      valueBubleOrg3Indx4: [],    
      valueBubleOrg3Indx5: [],       
      valueBublePerson4Indx0: [],
      valueBublePerson4Indx1: [],
      valueBublePerson4Indx2: [],    
      valueBublePerson4Indx3: [],
      valueBublePerson4Indx4: [],    
      valueBublePerson4Indx5: [], 
      valueBubleOrg4Indx0: [],
      valueBubleOrg4Indx1: [],
      valueBubleOrg4Indx2: [],    
      valueBubleOrg4Indx3: [],
      valueBubleOrg4Indx4: [],    
      valueBubleOrg4Indx5: [],               
      valueBublePerson5Indx0: [],
      valueBublePerson5Indx1: [],
      valueBublePerson5Indx2: [],    
      valueBublePerson5Indx3: [],
      valueBublePerson5Indx4: [],    
      valueBublePerson5Indx5: [], 
      valueBubleOrg5Indx0: [],
      valueBubleOrg5Indx1: [],
      valueBubleOrg5Indx2: [],    
      valueBubleOrg5Indx3: [],
      valueBubleOrg5Indx4: [],    
      valueBubleOrg5Indx5: [], 
      valueBublePerson0Positive: [],
      valueBublePerson0Negative: [],
      valueBublePerson0Netral: [],
      valueBublePerson1Positive: [],
      valueBublePerson1Negative: [],
      valueBublePerson1Netral: [],
      valueBublePerson2Positive: [],
      valueBublePerson2Negative: [],
      valueBublePerson2Netral: [],
      valueBublePerson3Positive: [],
      valueBublePerson3Negative: [],
      valueBublePerson3Netral: [],
      valueBublePerson4Positive: [],
      valueBublePerson4Negative: [],
      valueBublePerson4Netral: [],
      valueBublePerson5Positive: [],
      valueBublePerson5Negative: [],
      valueBublePerson5Netral: [],  
      // klik chart bar
      valueBubleOrg0Positive: [],
      valueBubleOrg0Negative: [],
      valueBubleOrg0Netral: [],
      valueBubleOrg1Positive: [],
      valueBubleOrg1Negative: [],
      valueBubleOrg1Netral: [],
      valueBubleOrg2Positive: [],
      valueBubleOrg2Negative: [],
      valueBubleOrg2Netral: [],
      valueBubleOrg3Positive: [],
      valueBubleOrg3Negative: [],
      valueBubleOrg3Netral: [],
      valueBubleOrg4Positive: [],
      valueBubleOrg4Negative: [],
      valueBubleOrg4Netral: [],
      valueBubleOrg5Positive: [],
      valueBubleOrg5Negative: [],
      valueBubleOrg5Netral: [],  
      // enddddddddd
    
  
      // =============================== end no delete 
      // =============================== end no delete 
      // =============================== end no delete                                             
      topik0: [],
      topik1: [],
      topik2: [],
      topik3: [],      
      today : [],
      yesterday : [],
      Last7Day: [],
      Last30Day: [],    
      // last 30 day                 
      // end last 30 day                               
      menu:false,      
      date1: (new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10),
      // date2: '2013-07-29',   
      date2: (new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10),  
      
    // date2: '2013-07-29',     
    // =========================================================== pagenation  variable 
    pagetotalcontent:"",
    pageplay:100,
    pagestart:0,
    pagelength:4,
    // =========================================================== end page 
      /*Chart sentiment analysis*/     
      sentimentanalysis: {
        chart: {
          id: 'Memory Usage'
        },
        dataLabels: {
          enabled: false
        },
        stroke: {
          curve: 'smooth',
          width: 2,
        },
        colors: ['#6F6F6F', '#FFB000', '#814AD6'], /*color line*/
        xaxis: {
           categories: []
        }
      },
        seriessentiment: [{
        name: 'Berita Online',
        data: []
      },
      {
        name: 'Twitter',
        data: []
      },
      {
        name: 'Youtube',
        data: []
      },     
      ],
      
      /*Chart buble*/
      chart: [
        {
          name: '',
          amount: 0,
          color: '#F88FB3',            
        },
        {
          name: '',
          amount: 0,
          color: '#F1E987'
        },
        {
          name: '',
          amount: 0,
          color: '#B3B8F4'
        },
        {
          name: '',
          amount: 0,
          color: '#5EC3C2',
        },
        {
          name: '',
          amount: 0,
          color: '#AFDAF5'
        },
        {
          name: '',
          amount: 0,
          color: '#C4C4C4'
        },
      ],
      /*end Chart buble*/

      /*pie*/
      seriess: [],
        chartOptionss: {
          colors:['#008FFB', '#FF4560', '#00E396'],
          chart: {
            width: 380,
            type: 'pie',
          },
          dataLabels: {
            enabled: false
          },        
          plotOptions: {
          pie: {
            donut: {
              labels: {
                show: true,
                name: {
                  show: true,
                  fontSize: '22px',
                  color: '#226077',
                  offsetY: -10,
                },
                total: {
                  show: true,
                },
              }
            }
          }
        },
      labels: ['Netral', 'Negative', 'Positive'],
      },

      /*radial*/
      seriesonline: [44, 55, 67, 83],
      onlinenew: {
        colors:['#38BABC', '#16A5A7', '#079092', '#057577', '#025354'],
        chart: {
          height: '50px',
          type: 'radialBar',
        },
        plotOptions: {
          radialBar: {
            dataLabels: {
              name: {
                fontSize: '22px',
              },
              value: {
                fontSize: '16px',
              },
              total: {
                show: true,
                label: 'Total',
              }
            }
          }
        },
        labels: ['series-1', 'series-2', 'series-3', 'series-4'],
      },

      /*bar chart*/
      series1: [{
            data: []
          }],
          barchart: {
              colors:['#38BABC', '#16A5A7', '#079092'],
            chart: {
              height: 350,
              type: 'bar',
            },
            plotOptions: {
              bar: {
                columnWidth: '45%',
                distributed: true,
              }
            },
            dataLabels: {
              enabled: false
            },
            legend: {
              show: false
            },
            xaxis: {
              categories: [              
              ],
              labels: {
                style: {
                  fontSize: '12px'
                }
              }
            }
          },
    }
  },

  /*Bubblechart*/
 computed: {
    transformedChartData() {
      return {
        name: 'Top Level',
        children: this.chart.map(chart => ({
          ...chart,
          size: chart.amount,
          parent: 'Top Level'
        }))
      }
    },
    layoutData() {
      // Generate a D3 hierarchy
      const rootHierarchy = hierarchy(this.transformedChartData)
        .sum(d => d.size)
        .sort((a, b) => {
          return b.value - a.value
        })
      // Pack the circles inside the viewbox
      return pack()
        .size([500, 500])
        .padding(10)(rootHierarchy)
    },

  /*methods chartbubble*/  
},
  mounted(){
    this.loadTopic()
    // this.loadKontenBerita()
    
    // this.loadSentimentanalysisInisialisasi()
  },
 methods: {
  async loadTopic(){
     // start loading 
      //  alert(this.topic_glob);
      axios.get("keyword_select",
      { headers:{'auth-token':localStorage.getItem('token_app')}},
      {dataType: 'json'}
      ).then((response) => {

        this.posts = response.data
        const data =response.data;
        
        for (let i = 0; i < data.length; i++) {  
            
            if(i == 1){
              this.selectedTopic = (data[i].KEYWORD);
            }
            this.topicsentiment.push(data[i].KEYWORD);
        }
        
        if(data.length > 0){
            this.loadKontenBerita();
        }
      })
      .catch((e) => {
         

      this.dialog = false;
      console.log(e)
          switch (e.response.status) {
              case 404:
                this.$refs.alert.error_login(404);
              break;
              case 403:
                this.$refs.alert.error_login(403);
               break;
              default:
                  console.log('some other error');  // end up here all the time
                  break;
          }
        // this.errors=e.response.data.msg;
      });  
  },
  async loadKontenBerita(){

    // console.log(this.$store.topic_glob);
    var date_start = this.date2 ;
        var date_end = this.date1;
         const date_awal = new Date();
         const date = new Date();
          date.setDate(date.getDate()+0);
        const datenow = date.toISOString().substr(0, 10);
        if(this.selectedPeriode == "Today"){ 
        this.click = 'Today'
           date_start = datenow;
           date_end = datenow;
        }
        if(this.selectedPeriode == "Yesterday"){ 
        this.click = 'Yesterday'
            date_awal.setDate(date_awal.getDate()-1);
            const date_c = date_awal.toISOString().substr(0, 10);
           date_start = date_c;
           date_end = date_c; 
        }
        if(this.selectedPeriode == "Last 7 Days" ||  this.selectedPeriode == "Previous Week"){ 
        this.click = 'Last 7 Days'
            date_awal.setDate(date_awal.getDate()-7);
            const date_c = date_awal.toISOString().substr(0, 10);

           date_start = date_c;
           date_end = datenow; 
        }
        if(this.selectedPeriode == "Last 30 Days" || this.selectedPeriode == "Previous Month"){ 
        this.click = 'Last 30 Days' 
            date_awal.setDate(date_awal.getDate()-30);
            const date_c = date_awal.toISOString().substr(0, 10);
           date_start = date_c;
           date_end = datenow; 
        }
     
      this.dialog = true;
    //  alert( this.selectedTopic2);
      try{
      const data1 = await axios.get("solr-dashboard?start_date="+date_start+"&end_date="+date_end+"&startpage=0&pageShow="+this.pageplay+"&topic="+this.selectedTopic+"&topic2="+this.selectedTopic2+"&city=",
          {headers:{'auth-token':localStorage.getItem('token_app')}}
          )
        const data = data1.data;
        this.$refs.topPersonComponent.loadKontenBerita();
        // data.data.forEach((element) => {
        //     console.log(element["source"]);
        // });
        
        //pie edol dan mednewa
        // this.onlinenew.labels =[]
        this.seriesonline = []
        this.seriesmedia = []
        this.valueTotalBerita = []
        this.valueTotalTwet = []
        this.valueTotalYt = []

        this.chartTweet = []
        if (data.chart.chart_twit != undefined) {
          this.chartTweet = data.chart.chart_twit //new
        }  
        this.chartNews = []
        if (data.chart.chart_news != undefined) {
          this.chartNews = data.chart.chart_news //new
        }  
        // this.chartNews = data.chart.chart_news //new
        this.chartCombinasi= [] //new
        this.pagelength = data.leghpage //new
        this.pagetotalcontent = data.total_content //new

        this.seriess = []
        this.kontenBerita = data.data  
        // inisialisasi topik 
      // inisialisasi tanggal     
        const tanggal = []
        // console.log(data.chart.chart_twit);
        this.chartTweet.forEach((element) => {
          tanggal.push(element["date"]);
        });
        this.chartNews.forEach((element) => {
          tanggal.push(element["date"]);
        });
          const Settanggal = [...new Set(tanggal)]                 
          const Settanggalreserve =  Settanggal.reverse().slice(0, 8)
          this.Settanggal = Settanggalreserve.reverse()     
          this.sentimentanalysis = {...this.sentimentanalysis, ...{
            xaxis: {
                categories: this.Settanggal,              
            }
          }}   
          // tanggal last 30
          this.EndDate = this.Settanggal.at(-1)
          var time = new Date(this.EndDate);
          time.setDate(time.getDate()-29);
          // this.StartDateLast30 = time.toISOString().substr(0, 10);

         
    // inisialisasi content all
      this.kontenBeritaPositive = []     
      this.kontenBeritaNegative = []
      this.kontenBeritaNetral = []
      
      for (let i = 0; i < data.data.length; i++) {       
          if (data.data[i].sentiment == 'Positive') {
              this.kontenBeritaPositive.push(data.data[i]);
          }
      }
      for (let i = 0; i < data.data.length; i++) {       
          if (data.data[i].sentiment == 'Negative') {
              this.kontenBeritaNegative.push(data.data[i]);
          }
      }
      for (let i = 0; i < data.data.length; i++) {       
          if (data.data[i].sentiment == 'Netral') {
              this.kontenBeritaNetral.push(data.data[i]);
          }
      }
    // end inisialisasi content all

    // inisialisasi content per sentiment twet, ytb dan berita
      this.mediaBerita = []
      this.mediaBeritaNetral = []
      this.mediaBeritaNegative = []
      this.mediaBeritaPositive = []
      for (let i = 0; i < data.data.length; i++) {       
          if (data.data[i].source == 'berita') {
              this.mediaBerita.push(data.data[i]);  
                if (data.data[i].sentiment == 'Positive') {
                    this.mediaBeritaPositive.push(data.data[i]);
                } 
                if (data.data[i].sentiment == 'Negative') {
                    this.mediaBeritaNegative.push(data.data[i]);
                } 
                if (data.data[i].sentiment == 'Netral') {
                    this.mediaBeritaNetral.push(data.data[i]);
                } 
          }
      }
      this.valueTotalBerita = this.mediaBerita.length

      this.MediatwitterShare = []
      this.kontenTwitterNetral  = []
      this.kontenTwitterNegative = []
      this.kontenTwitterPositive = []
      for (let i = 0; i < data.data.length; i++) {       
          if (data.data[i].source == 'twitter') {
              this.MediatwitterShare.push(data.data[i]);  
                if (data.data[i].sentiment == 'Negative') {
                    this.kontenTwitterNegative.push(data.data[i]);
                } 
                if (data.data[i].sentiment == 'Positive') {
                    this.kontenTwitterPositive.push(data.data[i]);
                } 
                if (data.data[i].sentiment == 'Netral') {
                    this.kontenTwitterNetral.push(data.data[i]);
                } 
          }
      }    
      // this.valueTotalTwet = this.MediatwitterShare.length
      
      this.MediaYtShare = []
      this.kontenYoutubePositive = []
      this.kontenYoutubeNegative = []
      this.kontenYoutubeNetral = []
       for (let i = 0; i < data.data.length; i++) {       
          if (data.data[i].source == 'youtube') {
              this.MediaYtShare.push(data.data[i]);
               // konten ytb
                if (data.data[i].sentiment == 'Positive') {
                    this.kontenYoutubePositive.push(data.data[i]);
                } 
                if (data.data[i].sentiment == 'Negative') {
                    this.kontenYoutubeNegative.push(data.data[i]);
                } 
                if (data.data[i].sentiment == 'Netral') {
                    this.kontenYoutubeNetral.push(data.data[i]);
                } 
               // end konten ytb
          }
      }     
      this.valueTotalYt = this.MediaYtShare.length
    // end inisialisasi content per sentiment


    // inisialisasi button jummlah per no page
      var cout_berita = 0;
      var cout_berita_positif = 0;
      var cout_berita_negativ = 0;
      var cout_berita_netral = 0;
      for (let i = 0; i < this.chartNews.length; i++) {       
            this.chartCombinasi.push(this.chartNews[i]);
              this.mediaBeritaNew.push(this.chartNews[i]);
              
              if (this.chartNews[i].Positive != undefined) {
                cout_berita += this.chartNews[i].Positive;
                cout_berita_positif += this.chartNews[i].Positive;
              }  
              if (this.chartNews[i].Negative != undefined) {
                cout_berita += this.chartNews[i].Negative;
                cout_berita_negativ += this.chartNews[i].Negative;
              }
              if (this.chartNews[i].Netral != undefined) {
                cout_berita += this.chartNews[i].Netral;
                cout_berita_netral += this.chartNews[i].Netral;
              }
      }  
      this.count_chart_mediaBeritaPositive=(cout_berita_positif);
      this.count_chart_mediaBeritaNegative=(cout_berita_negativ);
      this.count_chart_mediaBeritaNetral=(cout_berita_netral);
      


      var cout_tweet = 0;
      var cout_tweet_positif = 0;
      var cout_tweet_negativ = 0;
      var cout_tweet_netral = 0;
      for (let i = 0; i < this.chartTweet.length; i++) {       
            this.chartCombinasi.push(this.chartTweet[i]);
            this.MediatwitterShareNew.push(this.chartTweet[i]);
            // cout_tweet += this.chartTweet[i].Total;
              if (this.chartTweet[i].Positive != undefined) {
                cout_tweet += this.chartTweet[i].Positive;
                cout_tweet_positif += this.chartTweet[i].Positive;
              }  
              if (this.chartTweet[i].Negative != undefined) {
                cout_tweet += this.chartTweet[i].Negative;
                cout_tweet_negativ += this.chartTweet[i].Negative;
              }
              if (this.chartTweet[i].Netral != undefined) {
                cout_tweet += this.chartTweet[i].Netral;
                cout_tweet_netral += this.chartTweet[i].Netral;
              }
      }  

      this.count_chart_kontenTwitterPositive= (cout_tweet_positif) 
      this.count_chart_kontenTwitterNegative= (cout_tweet_negativ) 
      this.count_chart_kontenTwitterNetral= (cout_tweet_netral)  

      var cout_youtube = 0;
      var cout_youtube_positif = 0;
      var cout_youtube_negativ = 0;
      var cout_youtube_netral = 0;
      for (let i = 0; i < this.chartCombinasi.length; i++) {       
          if (this.chartCombinasi[i].nameChart == 'youtube') {
              this.MediaYtShareNew.push(this.chartCombinasi[i]);
              // cout_youtube += this.chartCombinasi[i].Total;
              if (this.chartCombinasi[i].Positive != undefined) {
                cout_youtube += this.chartCombinasi[i].Positive;
                cout_youtube_positif += this.chartCombinasi[i].Positive;
              }  
              if (this.chartCombinasi[i].Negative != undefined) {
                cout_youtube += this.chartCombinasi[i].Negative;
                cout_youtube_negativ += this.chartCombinasi[i].Negative;
              }
              if (this.chartCombinasi[i].Netral != undefined) {
                cout_youtube += this.chartCombinasi[i].Netral;
                cout_youtube_netral += this.chartCombinasi[i].Netral;
              }
          }
      }
        
      this.count_chart_kontenYoutubePositive=(cout_youtube_positif) 
      this.count_chart_kontenYoutubeNegative=(cout_youtube_negativ) 
      this.count_chart_kontenYoutubeNetral=(cout_youtube_netral)

      
      
      this.valueTotalBerita = cout_berita
      this.valueTotalTwet = cout_tweet;
      this.valueTotalYt = cout_youtube;
 
      var sentimen_categori_psitif = 0;
      var sentimen_categori_negative = 0;
      var sentimen_categori_netral = 0;
      var total_all = 0;
      for (let i = 0; i < this.chartCombinasi.length; i++) {       
          if (this.chartCombinasi[i].Positive != undefined) {
            total_all += this.chartCombinasi[i].Positive;
            sentimen_categori_psitif += this.chartCombinasi[i].Positive;
          }  
          if (this.chartCombinasi[i].Negative != undefined) {
            sentimen_categori_negative += this.chartCombinasi[i].Negative;
            total_all += this.chartCombinasi[i].Negative;
          }
          if (this.chartCombinasi[i].Netral != undefined) {
            sentimen_categori_netral += this.chartCombinasi[i].Netral;
            total_all += this.chartCombinasi[i].Netral;
          }
      }  

      const beritaNetralPersen = sentimen_categori_netral / total_all * 100 
      this.beritaNetralPersen = parseInt(beritaNetralPersen.toFixed(2))
      const beritaNegativePersen = sentimen_categori_negative / total_all * 100 
      this.beritaNegativePersen = parseInt(beritaNegativePersen.toFixed(2))
      const beritaPositvePersen = sentimen_categori_psitif / total_all * 100 
      this.beritaPositifPersen = parseInt(beritaPositvePersen.toFixed(2))
        
      // this.valueTotalYt = this.MediaYtShare.length

      // ================================================= buble cloud
      // ================================================= buble cloud
      // ================================================= buble cloud
      // ================================================= buble cloud
      // ================================================= buble cloud

      // insialisasi word cloud
      const word = []
      let domain = '';
          this.kontenBerita.forEach((element) => {
            
            const get_domain = element["domain"].split(".");
            if(get_domain.length == 2){
               domain = get_domain[0];
            }else if(get_domain.length == 3){
               domain = get_domain[1];
            }else{
               domain = element["domain"];
            }
            word.push(domain);
          });
          const SetttWord = []
      for (let i = 0; i < word.length; i++) {       
          SetttWord.push(word[i])
      }
      this.SetWord = [...new Set(SetttWord)]                                   
      for (let i = 0; i < data.data.length; i++) {    
          if (data.data[i].subtopik == this.SetWord[0]) {
            this.wordCloudIndx0.push(data.data[i])
          }         
      }     
      this.wordCloudIndx1 =[]     
      this.wordCloudIndx2 =[]     
      this.wordCloudIndx3 =[]     
      this.wordCloudIndx4 =[]     
      this.words[0] = [this.SetWord[0], this.wordCloudIndx0.length]
      for (let i = 0; i < data.data.length; i++) {    
          if (data.data[i].subtopik == this.SetWord[1]) {
            this.wordCloudIndx1.push(data.data[i])
          }         
      }          
      this.words[1] = [this.SetWord[1], this.wordCloudIndx1.length]
      for (let i = 0; i < data.data.length; i++) {    
          if (data.data[i].subtopik == this.SetWord[2]) {
            this.wordCloudIndx2.push(data.data[i])
          }         
      }          
      this.words[2] = [this.SetWord[2], this.wordCloudIndx2.length]
      for (let i = 0; i < data.data.length; i++) {    
          if (data.data[i].subtopik == this.SetWord[3]) {
            this.wordCloudIndx3.push(data.data[i])
          }         
      }          
      this.words[3] = [this.SetWord[3], this.wordCloudIndx3.length]
      for (let i = 0; i < data.data.length; i++) {    
          if (data.data[i].subtopik == this.SetWord[4]) {
            this.wordCloudIndx4.push(data.data[i])
          }         
      }          
      this.words[4] = [this.SetWord[4], this.wordCloudIndx4.length]      
      // end word cloud 
      
      // inisialisasi person
      const person = []
      const person2 = []
      this.kontenBerita.forEach((element) => {
        if(element["ner_person"] != ''  && element["ner_person"] != null ){
          person.push(element["ner_person"]);
          person2.push(element["ner_person"]);
        }
      });
      const SetttPerson = []
          const SetttPerson2 = []
      for (let i = 0; i < person.length; i++) {       
          SetttPerson.push(person[i].at(-0))     
          SetttPerson2.push(person2[i].at(-1))
      }
      const Setperson = [...new Set(SetttPerson)]     
        const Setperson2 = [...new Set(SetttPerson2)]            
        const Setperson3 = Setperson.concat(Setperson2)

        this.SetPerson =  [...new Set(Setperson3)]
         
      this.chartBubleIndx0 =[]  
        for (let i = 0; i < data.data.length; i++) {  
          if (data.data[i].ner_person != null) {  //tambahan karna data ada yang null
            if(data.data[i].ner_person[0] != '' && data.data[i].ner_person[0] != null){  //tambahan karna data ada yang null
              if (data.data[i].ner_person[0] == this.SetPerson[0]) {
                this.chartBubleIndx0.push(data.data[i])
              }   
            }
          }      
      }          
      for (let i = 0; i < data.data.length; i++) {    
        if (data.data[i].ner_person != null) {  //tambahan karna data ada yang null
          if(data.data[i].ner_person[1] != '' && data.data[i].ner_person[1] != null){  //tambahan karna data ada yang null
            if (data.data[i].ner_person[1] == this.SetPerson[0]) {
              this.chartBubleIndx0.push(data.data[i])
            }  
          }
        }       
      } 
      this.chart[0].name = this.SetPerson[0]
      this.chart[0].amount = this.chartBubleIndx0.length
      this.chartBubleIndx1 =[]  
      for (let i = 0; i < data.data.length; i++) {   
          
        if (data.data[i].ner_person != null) {  //tambahan karna data ada yang null
          if(data.data[i].ner_person[0] != '' && data.data[i].ner_person[0] != null){  //tambahan karna data ada yang null 
            if (data.data[i].ner_person[0] == this.SetPerson[1]) {
              this.chartBubleIndx1.push(data.data[i])
            }   
          }
        }      
      }          
      for (let i = 0; i < data.data.length; i++) {  
          if (data.data[i].ner_person != null) {  //tambahan karna data ada yang null
            if(data.data[i].ner_person[1] != '' && data.data[i].ner_person[1] != null){  //tambahan karna data ada yang null  
              if (data.data[i].ner_person[1] == this.SetPerson[1]) {
                this.chartBubleIndx1.push(data.data[i])
              }         
            }
          }
      }          
      this.chart[1].name = this.SetPerson[1]
      this.chart[1].amount = this.chartBubleIndx1.length
      this.chartBubleIndx2 =[]  
        for (let i = 0; i < data.data.length; i++) {    
          if (data.data[i].ner_person != null) {  //tambahan karna data ada yang null
            if(data.data[i].ner_person[0] != '' && data.data[i].ner_person[0] != null){  //tambahan karna data ada yang null
              if (data.data[i].ner_person[0] == this.SetPerson[2]) {
                this.chartBubleIndx2.push(data.data[i])
              }         
            }
          }
      }          
      for (let i = 0; i < data.data.length; i++) {  
          if (data.data[i].ner_person != null) {  //tambahan karna data ada yang null
            if(data.data[i].ner_person[1] != '' && data.data[i].ner_person[1] != null){  //tambahan karna data ada yang null  
              if (data.data[i].ner_person[1] == this.SetPerson[2]) {
                this.chartBubleIndx2.push(data.data[i])
              }         
            }
          }
      }          
      this.chart[2].name = this.SetPerson[2]
      this.chart[2].amount = this.chartBubleIndx2.length
      this.chartBubleIndx3 =[]  
        for (let i = 0; i < data.data.length; i++) {  
          if (data.data[i].ner_person != null) {  //tambahan karna data ada yang null
            if(data.data[i].ner_person[0] != '' && data.data[i].ner_person[0] != null){  //tambahan karna data ada yang null  
              if (data.data[i].ner_person[0] == this.SetPerson[3]) {
                this.chartBubleIndx3.push(data.data[i])
              }        
            }
          } 
      }          
      for (let i = 0; i < data.data.length; i++) {  
          if (data.data[i].ner_person != null) {  //tambahan karna data ada yang null
            if(data.data[i].ner_person[1] != '' && data.data[i].ner_person[1] != null){  //tambahan karna data ada yang null  
              if (data.data[i].ner_person[1] == this.SetPerson[3]) {
                this.chartBubleIndx3.push(data.data[i])
              }  
            }
          }       
      }          
      this.chart[3].name = this.SetPerson[3]
      this.chart[3].amount = this.chartBubleIndx3.length
      this.chartBubleIndx4 =[]  
        for (let i = 0; i < data.data.length; i++) {  
          
          if (data.data[i].ner_person != null) {  //tambahan karna data ada yang null
            if(data.data[i].ner_person[0] != '' && data.data[i].ner_person[0] != null){  //tambahan karna data ada yang null  
              if (data.data[i].ner_person[0] == this.SetPerson[4]) {
                this.chartBubleIndx4.push(data.data[i])
              }     
            }
          }    
      }          
      for (let i = 0; i < data.data.length; i++) {  
          if (data.data[i].ner_person != null) {  //tambahan karna data ada yang null
            if(data.data[i].ner_person[1] != '' && data.data[i].ner_person[1] != null){  //tambahan karna data ada yang null  
              if (data.data[i].ner_person[1] == this.SetPerson[4]) {
                this.chartBubleIndx4.push(data.data[i])
              }         
            }
          }
      }     
      this.chart[4].name = this.SetPerson[4]     
      this.chart[4].amount = this.chartBubleIndx4.length
      this.chartBubleIndx5 =[]  
        for (let i = 0; i < data.data.length; i++) {    
          if (data.data[i].ner_person != null) {  //tambahan karna data ada yang null
            if(data.data[i].ner_person[0] != '' && data.data[i].ner_person[0] != null){  //tambahan karna data ada yang null
              if (data.data[i].ner_person[0] == this.SetPerson[5]) {
                this.chartBubleIndx5.push(data.data[i])
              }    
            }
          }     
      }          
      for (let i = 0; i < data.data.length; i++) {    
          if (data.data[i].ner_person != null) {  //tambahan karna data ada yang null
            if(data.data[i].ner_person[1] != '' && data.data[i].ner_person[1] != null){  //tambahan karna data ada yang null
              if (data.data[i].ner_person[1] == this.SetPerson[5]) {
                this.chartBubleIndx5.push(data.data[i])
              }     
            }
          }    
      }          
      this.chart[5].name = this.SetPerson[5]
      this.chart[5].amount = this.chartBubleIndx5.length  
      
      this.series1[0].data = [this.chartBubleIndx0.length, this.chartBubleIndx1.length, this.chartBubleIndx2.length, this.chartBubleIndx3.length, this.chartBubleIndx4.length, this.chartBubleIndx5.length]
      // inisialisasi organisasi
       const organisasi = []      
      const organisasi2 = []
        this.kontenBerita.forEach((element) => {
            if(element["ner_organization"] != ''  && element["ner_organization"] != null ){
                organisasi.push(element["ner_organization"]);
                organisasi2.push(element["ner_organization"]);
            }
        });
          const SetttOrganisasi = []
          const SetttOrganisasi2 = []
      for (let i = 0; i < organisasi.length; i++) {       
          SetttOrganisasi.push(organisasi[i].at(-0))    
          SetttOrganisasi2.push(organisasi2[i].at(-1))
      }
        const Setorganisasi = [...new Set(SetttOrganisasi)]   
          // this.kontenBerita.forEach((element) => {
          //   organisasi2.push(element["ner_organization"]);
          // });
      // for (let i = 0; i < organisasi2.length; i++) {       
      //     SetttOrganisasi2.push(organisasi2[i].at(-1))
      // }
      const Setorganisasi2 = [...new Set(SetttOrganisasi2)]            
      const Setorganisasi3 = Setorganisasi.concat(Setorganisasi2)
      this.SetOrganisasi =  [...new Set(Setorganisasi3)]
      this.chartBubleIndx0Org =[]  
       for (let i = 0; i < data.data.length; i++) {  
        if (data.data[i].ner_organization != null) {  //tambahan karna data ada yang null
          if(data.data[i].ner_organization[0] != '' && data.data[i].ner_organization[0] != null){  //tambahan karna data ada yang null  
            if (data.data[i].ner_organization[0] == this.SetOrganisasi[0]) {
              this.chartBubleIndx0Org.push(data.data[i])
            }   
          }
        }      
      }          
      for (let i = 0; i < data.data.length; i++) {    
        if (data.data[i].ner_organization != null) {  //tambahan karna data ada yang null
          if(data.data[i].ner_organization[1] != '' && data.data[i].ner_organization[1] != null){  //tambahan karna data ada yang null 
            if (data.data[i].ner_organization[1] == this.SetOrganisasi[0]) {
              this.chartBubleIndx0Org.push(data.data[i])
            }  
          }
        }       
      }    
      this.chartBubleIndx1Org =[]  
        for (let i = 0; i < data.data.length; i++) {    
        if (data.data[i].ner_organization != null) {  //tambahan karna data ada yang null
          if(data.data[i].ner_organization[0] != '' && data.data[i].ner_organization[0] != null){  //tambahan karna data ada yang null
            if (data.data[i].ner_organization[0] == this.SetOrganisasi[1]) {
              this.chartBubleIndx1Org.push(data.data[i])
            }     
          }
        }    
      }          
      for (let i = 0; i < data.data.length; i++) {    
        if (data.data[i].ner_organization != null) {  //tambahan karna data ada yang null
          if(data.data[i].ner_organization[1] != '' && data.data[i].ner_organization[1] != null){  //tambahan karna data ada yang null
            if (data.data[i].ner_organization[1] == this.SetOrganisasi[1]) {
              this.chartBubleIndx1Org.push(data.data[i])
            }     
          }
        }    
      }          
      this.chartBubleIndx2Org =[]  
      for (let i = 0; i < data.data.length; i++) {  
        if (data.data[i].ner_organization != null) {  //tambahan karna data ada yang null
          if(data.data[i].ner_organization[0] != '' && data.data[i].ner_organization[0] != null){  //tambahan karna data ada yang null  
            if (data.data[i].ner_organization[0] == this.SetOrganisasi[2]) {
              this.chartBubleIndx2Org.push(data.data[i])
            }  
          }
        }       
      }          
      for (let i = 0; i < data.data.length; i++) {    
        if (data.data[i].ner_organization != null) {  //tambahan karna data ada yang null
          if(data.data[i].ner_organization[1] != '' && data.data[i].ner_organization[1] != null){  //tambahan karna data ada yang null
            if (data.data[i].ner_organization[1] == this.SetOrganisasi[2]) {
              this.chartBubleIndx2Org.push(data.data[i])
            }   
          }
        }      
      }           
      this.chartBubleIndx3Org =[]  
        for (let i = 0; i < data.data.length; i++) {  
        if (data.data[i].ner_organization != null) {  //tambahan karna data ada yang null
          if(data.data[i].ner_organization[0] != '' && data.data[i].ner_organization[0] != null){  //tambahan karna data ada yang null  
            if (data.data[i].ner_organization[0] == this.SetOrganisasi[3]) {
              this.chartBubleIndx3Org.push(data.data[i])
            }         
          }
        }
      }          
      for (let i = 0; i < data.data.length; i++) {    
        if (data.data[i].ner_organization != null) {  //tambahan karna data ada yang null
          if(data.data[i].ner_organization[1] != '' && data.data[i].ner_organization[1] != null){  //tambahan karna data ada yang null
            if (data.data[i].ner_organization[1] == this.SetOrganisasi[3]) {
              this.chartBubleIndx3Org.push(data.data[i])
            }         
          }
        }
      }          
      this.chartBubleIndx4Org =[]    
         for (let i = 0; i < data.data.length; i++) {   
        if (data.data[i].ner_organization != null) {  //tambahan karna data ada yang null
          if(data.data[i].ner_organization[0] != '' && data.data[i].ner_organization[0] != null){  //tambahan karna data ada yang null
            if (data.data[i].ner_organization[0] == this.SetOrganisasi[4]) {
              this.chartBubleIndx4Org.push(data.data[i])
            }       
          }
        }  
      }          
      for (let i = 0; i < data.data.length; i++) {   
        if (data.data[i].ner_organization != null) {  //tambahan karna data ada yang null
          if(data.data[i].ner_organization[1] != '' && data.data[i].ner_organization[1] != null){  //tambahan karna data ada yang null 
            if (data.data[i].ner_organization[1] == this.SetOrganisasi[4]) {
              this.chartBubleIndx4Org.push(data.data[i])
            }     
          }
        }    
      } 
      this.chartBubleIndx5Org =[]  
      for (let i = 0; i < data.data.length; i++) {   
        if (data.data[i].ner_organization != null) {  //tambahan karna data ada yang null
          if(data.data[i].ner_organization[0] != '' && data.data[i].ner_organization[0] != null){  //tambahan karna data ada yang null
            if (data.data[i].ner_organization[0] == this.SetOrganisasi[5]) {
              this.chartBubleIndx5Org.push(data.data[i])
            }      
          }
        }   
      }          
      for (let i = 0; i < data.data.length; i++) {   
        if (data.data[i].ner_organization != null) {  //tambahan karna data ada yang null
          if(data.data[i].ner_organization[1] != '' && data.data[i].ner_organization[1] != null){  //tambahan karna data ada yang null
            if (data.data[i].ner_organization[1] == this.SetOrganisasi[5]) {
              this.chartBubleIndx5Org.push(data.data[i])
            }        
          }
        } 
      }           
      this.barchart.xaxis.categories[0] = this.SetPerson[0]
      this.barchart.xaxis.categories[1] = this.SetPerson[1]
      this.barchart.xaxis.categories[2] = this.SetPerson[2]
      this.barchart.xaxis.categories[3] = this.SetPerson[3]
      this.barchart.xaxis.categories[4] = this.SetPerson[4]
      this.barchart.xaxis.categories[5] = this.SetPerson[5]


    
      // chart buble
      for (let i = 0; i < this.mediaBerita.length; i++) {    
        if (data.data[i].ner_person != null) {  //tambahan karna data ada yang null
          if(data.data[i].ner_person[0] != '' && data.data[i].ner_person[0] != null){  //tambahan karna data ada yang null   
            if (data.data[i].ner_person[0] == this.SetPerson[0]) {
              this.valueBubleIndx0Berita.push(data.data[i]);
            }    
          }
        }     
      }  
      for (let i = 0; i < this.mediaBerita.length; i++) {   
        if (data.data[i].ner_person != null) {  //tambahan karna data ada yang null
          if(data.data[i].ner_person[1] != '' && data.data[i].ner_person[1] != null){  //tambahan karna data ada yang null      
            if (data.data[i].ner_person[1] == this.SetPerson[0]) {
              this.valueBubleIndx0Berita.push(data.data[i]);
            }         
          }
        }
      }  
      for (let i = 0; i < this.mediaBerita.length; i++) {  
        if (data.data[i].ner_person != null) {  //tambahan karna data ada yang null
          if(data.data[i].ner_person[0] != '' && data.data[i].ner_person[0] != null){  //tambahan karna data ada yang null       
            if (data.data[i].ner_person[0] == this.SetPerson[1]) {
              this.valueBubleIndx1Berita.push(data.data[i]);
            }  
          }
        }       
      }  
      for (let i = 0; i < this.mediaBerita.length; i++) { 
        if (data.data[i].ner_person != null) {  //tambahan karna data ada yang null
          if(data.data[i].ner_person[1] != '' && data.data[i].ner_person[1] != null){  //tambahan karna data ada yang null        
            if (data.data[i].ner_person[1] == this.SetPerson[1]) {
              this.valueBubleIndx1Berita.push(data.data[i]);
            }  
          }
        }       
      }  
      for (let i = 0; i < this.mediaBerita.length; i++) { 
        if (data.data[i].ner_person != null) {  //tambahan karna data ada yang null
          if(data.data[i].ner_person[0] != '' && data.data[i].ner_person[0] != null){  //tambahan karna data ada yang null        
            if (data.data[i].ner_person[0] == this.SetPerson[2]) {
              this.valueBubleIndx2Berita.push(data.data[i]);
            }    
          }
        }     
      }  
      for (let i = 0; i < this.mediaBerita.length; i++) {  
        if (data.data[i].ner_person != null) {  //tambahan karna data ada yang null
          if(data.data[i].ner_person[1] != '' && data.data[i].ner_person[1] != null){  //tambahan karna data ada yang null       
            if (data.data[i].ner_person[1] == this.SetPerson[2]) {
              this.valueBubleIndx2Berita.push(data.data[i]);
            }         
          }
        }
      }  
      for (let i = 0; i < this.mediaBerita.length; i++) {  
        if (data.data[i].ner_person != null) {  //tambahan karna data ada yang null
          if(data.data[i].ner_person[0] != '' && data.data[i].ner_person[0] != null){  //tambahan karna data ada yang null       
            if (data.data[i].ner_person[0] == this.SetPerson[3]) {
              this.valueBubleIndx3Berita.push(data.data[i]);
            }    
          }
        }     
      }  
      for (let i = 0; i < this.mediaBerita.length; i++) {   
        if (data.data[i].ner_person != null) {  //tambahan karna data ada yang null
          if(data.data[i].ner_person[1] != '' && data.data[i].ner_person[1] != null){  //tambahan karna data ada yang null      
            if (data.data[i].ner_person[1] == this.SetPerson[3]) {
              this.valueBubleIndx3Berita.push(data.data[i]);
            }      
          }
        }   
      }  
      for (let i = 0; i < this.mediaBerita.length; i++) {     
        if (data.data[i].ner_person != null) {  //tambahan karna data ada yang null
          if(data.data[i].ner_person[0] != '' && data.data[i].ner_person[0] != null){  //tambahan karna data ada yang null    
            if (data.data[i].ner_person[0] == this.SetPerson[4]) {
              this.valueBubleIndx4Berita.push(data.data[i]);
            }         
          }
        }
      }  
      for (let i = 0; i < this.mediaBerita.length; i++) {   
        if (data.data[i].ner_person != null) {  //tambahan karna data ada yang null
          if(data.data[i].ner_person[1] != '' && data.data[i].ner_person[1] != null){  //tambahan karna data ada yang null      
            if (data.data[i].ner_person[1] == this.SetPerson[4]) {
              this.valueBubleIndx4Berita.push(data.data[i]);
            }   
          }
        }      
      }
      for (let i = 0; i < this.mediaBerita.length; i++) {
        if (data.data[i].ner_person != null) {  //tambahan karna data ada yang null
          if(data.data[i].ner_person[0] != '' && data.data[i].ner_person[0] != null){  //tambahan karna data ada yang null         
            if (data.data[i].ner_person[0] == this.SetPerson[5]) {
              this.valueBubleIndx5Berita.push(data.data[i]);
            }    
          }
        }     
      }  
      for (let i = 0; i < this.mediaBerita.length; i++) {    
        if (data.data[i].ner_person != null) {  //tambahan karna data ada yang null
          if(data.data[i].ner_person[1] != '' && data.data[i].ner_person[1] != null){  //tambahan karna data ada yang null     
            if (data.data[i].ner_person[1] == this.SetPerson[5]) {
              this.valueBubleIndx5Berita.push(data.data[i]);
            }        
          }
        } 
      }
       for (let i = 0; i < this.mediaBerita.length; i++) {    
        if (data.data[i].ner_organization != null) {  //tambahan karna data ada yang null
          if(data.data[i].ner_organization[0] != '' && data.data[i].ner_organization[0] != null){  //tambahan karna data ada yang null     
            if (data.data[i].ner_organization[0] == this.SetOrganisasi[0]) {
              this.valueBubleIndx0OrgBerita.push(data.data[i]);
            }  
          }
        }       
      }  
      for (let i = 0; i < this.mediaBerita.length; i++) {   
        if (data.data[i].ner_organization != null) {  //tambahan karna data ada yang null
          if(data.data[i].ner_organization[1] != '' && data.data[i].ner_organization[1] != null){  //tambahan karna data ada yang null      
            if (data.data[i].ner_organization[1] == this.SetOrganisasi[0]) {
              this.valueBubleIndx0OrgBerita.push(data.data[i]);
            }     
          }
        }    
      }  
      for (let i = 0; i < this.mediaBerita.length; i++) {   
        if (data.data[i].ner_organization != null) {  //tambahan karna data ada yang null
          if(data.data[i].ner_organization[0] != '' && data.data[i].ner_organization[0] != null){  //tambahan karna data ada yang null      
            if (data.data[i].ner_organization[0] == this.SetOrganisasi[1]) {
              this.valueBubleIndx1OrgBerita.push(data.data[i]);
            }  
          }
        }       
      }  
      for (let i = 0; i < this.mediaBerita.length; i++) {   
        if (data.data[i].ner_organization != null) {  //tambahan karna data ada yang null
          if(data.data[i].ner_organization[1] != '' && data.data[i].ner_organization[1] != null){  //tambahan karna data ada yang null      
            if (data.data[i].ner_organization[1] == this.SetOrganisasi[1]) {
              this.valueBubleIndx1OrgBerita.push(data.data[i]);
            }     
          }
        }    
      }  
      for (let i = 0; i < this.mediaBerita.length; i++) {  
        if (data.data[i].ner_organization != null) {  //tambahan karna data ada yang null
          if(data.data[i].ner_organization[0] != '' && data.data[i].ner_organization[0] != null){  //tambahan karna data ada yang null       
            if (data.data[i].ner_organization[0] == this.SetOrganisasi[2]) {
              this.valueBubleIndx2OrgBerita.push(data.data[i]);
            }      
          }
        }   
      }  
      for (let i = 0; i < this.mediaBerita.length; i++) {   
        if (data.data[i].ner_organization != null) {  //tambahan karna data ada yang null
          if(data.data[i].ner_organization[1] != '' && data.data[i].ner_organization[1] != null){  //tambahan karna data ada yang null      
            if (data.data[i].ner_organization[1] == this.SetOrganisasi[2]) {
              this.valueBubleIndx2OrgBerita.push(data.data[i]);
            }         
          }
        }
      }  
      for (let i = 0; i < this.mediaBerita.length; i++) {   
        if (data.data[i].ner_organization != null) {  //tambahan karna data ada yang null
          if(data.data[i].ner_organization[0] != '' && data.data[i].ner_organization[0] != null){  //tambahan karna data ada yang null      
            if (data.data[i].ner_organization[0] == this.SetOrganisasi[3]) {
              this.valueBubleIndx3OrgBerita.push(data.data[i]);
            }         
          }
        }
      }  
      for (let i = 0; i < this.mediaBerita.length; i++) {   
        if (data.data[i].ner_organization != null) {  //tambahan karna data ada yang null
          if(data.data[i].ner_organization[1] != '' && data.data[i].ner_organization[1] != null){  //tambahan karna data ada yang null      
            if (data.data[i].ner_organization[1] == this.SetOrganisasi[3]) {
              this.valueBubleIndx3OrgBerita.push(data.data[i]);
            }         
          }
        }
      }  
      for (let i = 0; i < this.mediaBerita.length; i++) {       
        if (data.data[i].ner_organization != null) {  //tambahan karna data ada yang null
          if(data.data[i].ner_organization[0] != '' && data.data[i].ner_organization[0] != null){  //tambahan karna data ada yang null  
            if (data.data[i].ner_organization[0] == this.SetOrganisasi[4]) {
              this.valueBubleIndx4OrgBerita.push(data.data[i]);
            }   
          }
        }      
      }  
      for (let i = 0; i < this.mediaBerita.length; i++) {   
        if (data.data[i].ner_organization != null) {  //tambahan karna data ada yang null
          if(data.data[i].ner_organization[1] != '' && data.data[i].ner_organization[1] != null){  //tambahan karna data ada yang null      
            if (data.data[i].ner_organization[1] == this.SetOrganisasi[4]) {
              this.valueBubleIndx4OrgBerita.push(data.data[i]);
            }         
          }
        }
      }      
      for (let i = 0; i < this.mediaBerita.length; i++) {       
        if (data.data[i].ner_organization != null) {  //tambahan karna data ada yang null
          if(data.data[i].ner_organization[0] != '' && data.data[i].ner_organization[0] != null){  //tambahan karna data ada yang null  
            if (data.data[i].ner_organization[0] == this.SetOrganisasi[5]) {
              this.valueBubleIndx5OrgBerita.push(data.data[i]);
            }      
          }
        }   
      }  
      for (let i = 0; i < this.mediaBerita.length; i++) {    
        if (data.data[i].ner_organization != null) {  //tambahan karna data ada yang null
          if(data.data[i].ner_organization[1] != '' && data.data[i].ner_organization[1] != null){  //tambahan karna data ada yang null     
            if (data.data[i].ner_organization[1] == this.SetOrganisasi[5]) {
              this.valueBubleIndx5OrgBerita.push(data.data[i]);
            }     
          }
        }    
      }          
      // // end sentiment berita

      this.seriessentiment[0].data = []
      this.seriessentiment[1].data = []
      this.seriessentiment[2].data = []
      // this.series1 = []
      if(data.data.length > 0){
          this.loadSentimentanalysisInisialisasi(data);
        }else{
          
        this.alert = true
          setTimeout(() => {
            this.alert = false;
          }, 4000);
          this.message = "Data Not Found" 
          this.colorAlert = "red"
        }
        
        setTimeout(() => {
            this.dialog = false;
          }, 3000);
      }catch(e){
        this.alert = true
          setTimeout(() => {
            this.alert = false;
          }, 3000);
          this.message = "Data Not Found" 
          this.colorAlert = "red"
        this.dialog = false;
      // this.dialog = true;
        console.log('error')
        console.log(e)
      }
    }, 

    // ================================================================
    // ========================= sentimen =============================
    // ================================================================
     //sentimentanalysis
     async loadSentimentanalysisInisialisasi(data){
      try{
        
        // ======================================================================================= Grafik content per sentiment
          
          var count_news0 = 0;
          var count_news1 = 0;
          var count_news2 = 0;
          var count_news3 = 0;
          var count_news4 = 0;
          var count_news5 = 0;
          var count_news6 = 0;
          var count_news7 = 0;
          for (let i = 0; i < this.mediaBeritaNew.length; i++) {       
              if (this.mediaBeritaNew[i].date == this.Settanggal[0]) {
                  count_news0 += this.mediaBeritaNew[i].Total;
              }
          }
          // this.tnglIndex0.push(count_news0);
          // this.tnglIndex1 = []
          for (let i = 0; i < this.mediaBeritaNew.length; i++) {       
              if (this.mediaBeritaNew[i].date == this.Settanggal[1]) {
                  count_news1 += this.mediaBeritaNew[i].Total;
              }
          }
          // this.tnglIndex1.push(count_news1);
          // this.tnglIndex2 = []
          for (let i = 0; i < this.mediaBeritaNew.length; i++) {       
              if (this.mediaBeritaNew[i].date == this.Settanggal[2]) {
                  count_news2 += this.mediaBeritaNew[i].Total;
              }
          }
          // this.tnglIndex2.push(count_news2);
          // this.tnglIndex3 = []
          for (let i = 0; i < this.mediaBeritaNew.length; i++) {       
              if (this.mediaBeritaNew[i].date == this.Settanggal[3]) {
                  count_news3 += this.mediaBeritaNew[i].Total;
              }
          }
          // this.tnglIndex3.push(count_news3);
          // this.tnglIndex4 = []
          for (let i = 0; i < this.mediaBeritaNew.length; i++) {       
              if (this.mediaBeritaNew[i].date == this.Settanggal[4]) {
                  count_news4 += this.mediaBeritaNew[i].Total;
              }
          }
          // this.tnglIndex4.push(count_news4);
          // this.tnglIndex5 = []
          for (let i = 0; i < this.mediaBeritaNew.length; i++) {       
              if (this.mediaBeritaNew[i].date == this.Settanggal[5]) {
                  count_news5 += this.mediaBeritaNew[i].Total;
              }
          }
          // this.tnglIndex5.push(count_news5);
          // this.tnglIndex6 = []
          for (let i = 0; i < this.mediaBeritaNew.length; i++) {       
              if (this.mediaBeritaNew[i].date == this.Settanggal[6]) {
                  count_news6 += this.mediaBeritaNew[i].Total;
              }
          }
          // this.tnglIndex6.push(count_news6);
          // this.tnglIndex7 = []
          for (let i = 0; i < this.mediaBeritaNew.length; i++) {       
              if (this.mediaBeritaNew[i].date == this.Settanggal[7]) {
                  count_news7 += this.mediaBeritaNew[i].Total;
              }
          }    
          
   
          // this.tnglIndex7.push(count_news7); 
          // ================== end topik berita
          // topik twet
          // this.tnglIndex0Twet = []
          
          var count_tweet0 = 0;
          var count_tweet1 = 0;
          var count_tweet2 = 0;
          var count_tweet3 = 0;
          var count_tweet4 = 0;
          var count_tweet5 = 0;
          var count_tweet6 = 0;
          var count_tweet7 = 0;
          for (let i = 0; i < this.MediatwitterShareNew.length; i++) {       
              if (this.MediatwitterShareNew[i].date == this.Settanggal[0]) {
                  count_tweet0 += this.MediatwitterShareNew[i].Total;
              }        
          }
          
          // this.tnglIndex0Twet.push(count_tweet0);
          // this.tnglIndex1Twet = []
          for (let i = 0; i < this.MediatwitterShareNew.length; i++) {       
              if (this.MediatwitterShareNew[i].date == this.Settanggal[1]) {
                  count_tweet1 += this.MediatwitterShareNew[i].Total;
              }
          }
          
          // this.tnglIndex1Twet.push(count_tweet1);
          // this.tnglIndex2Twet = []
          for (let i = 0; i < this.MediatwitterShareNew.length; i++) {       
              if (this.MediatwitterShareNew[i].date == this.Settanggal[2]) {
                  count_tweet2 += this.MediatwitterShareNew[i].Total;
              }
          }
          // this.tnglIndex2Twet.push(count_tweet2);
          // this.tnglIndex3Twet = []
          for (let i = 0; i < this.MediatwitterShareNew.length; i++) {       
              if (this.MediatwitterShareNew[i].date == this.Settanggal[3]) {
                  count_tweet3 += this.MediatwitterShareNew[i].Total;
              }
          }
          // this.tnglIndex3Twet.push(count_tweet3);
          // this.tnglIndex4Twet = []
          for (let i = 0; i < this.MediatwitterShareNew.length; i++) {       
              if (this.MediatwitterShareNew[i].date == this.Settanggal[4]) {
                  count_tweet4 += this.MediatwitterShareNew[i].Total;
              }
          }
          // this.tnglIndex4Twet.push(count_tweet4);
          // this.tnglIndex5Twet = []
          for (let i = 0; i < this.MediatwitterShareNew.length; i++) {       
              if (this.MediatwitterShareNew[i].date == this.Settanggal[5]) {
                  count_tweet5 += this.MediatwitterShareNew[i].Total;
              }
          }
          // this.tnglIndex5Twet.push(count_tweet5);
          // this.tnglIndex6Twet = []
          for (let i = 0; i < this.MediatwitterShareNew.length; i++) {       
              if (this.MediatwitterShareNew[i].date == this.Settanggal[6]) {
                  count_tweet6 += this.MediatwitterShareNew[i].Total;
              }
          }
          // this.tnglIndex6Twet.push(count_tweet6);
          // this.tnglIndex7Twet = []
          for (let i = 0; i < this.MediatwitterShareNew.length; i++) {       
              if (this.MediatwitterShareNew[i].date == this.Settanggal[7]) {
                  count_tweet7 += this.MediatwitterShareNew[i].Total;
              }
          }   
          // this.tnglIndex7Twet.push(count_tweet7);
          // end topik twet

          // topik yt
          this.tnglIndex0Yt = []
          var count_Yt0 = 0;
          var count_Yt1 = 0;
          var count_Yt2 = 0;
          var count_Yt3 = 0;
          var count_Yt4 = 0;
          var count_Yt5 = 0;
          var count_Yt6 = 0;
          var count_Yt7 = 0;
            for (let i = 0; i < this.MediaYtShareNew.length; i++) {       
              if (this.MediaYtShareNew[i].dateid == this.Settanggal[0]) {
                  count_Yt0 += this.MediaYtShareNew[i].Total;
              }
          }
          
          // this.tnglIndex0Yt.push(count_Yt0);
          // this.tnglIndex1Yt = []
          for (let i = 0; i < this.MediaYtShareNew.length; i++) {               
              if (this.MediaYtShareNew[i].dateid == this.Settanggal[1]) {
                  count_Yt1 += this.MediaYtShareNew[i].Total;
              }
          }
          // this.tnglIndex1Yt.push(count_Yt1);
          // this.tnglIndex2Yt = []
          for (let i = 0; i < this.MediaYtShareNew.length; i++) {       
              if (this.MediaYtShareNew[i].dateid == this.Settanggal[2]) {
                  count_Yt2 += this.MediaYtShareNew[i].Total;
              }
          }
          // this.tnglIndex2Yt.push(count_Yt2);
          // this.tnglIndex3Yt = []
          for (let i = 0; i < this.MediaYtShareNew.length; i++) {       
              if (this.MediaYtShareNew[i].dateid == this.Settanggal[3]) {
                  count_Yt3 += this.MediaYtShareNew[i].Total;
              }
          }
          // this.tnglIndex3Yt.push(count_Yt3);
          // this.tnglIndex4Yt = []
          for (let i = 0; i < this.MediaYtShareNew.length; i++) {       
              if (this.MediaYtShareNew[i].dateid == this.Settanggal[4]) {
                  count_Yt4 += this.MediaYtShareNew[i].Total;
              }
          }
          // this.tnglIndex4Yt.push(count_Yt4);
          // this.tnglIndex5Yt = []
          for (let i = 0; i < this.MediaYtShareNew.length; i++) {       
              if (this.MediaYtShareNew[i].dateid == this.Settanggal[5]) {
                  count_Yt5 += this.MediaYtShareNew[i].Total;
              }
          }
          // this.tnglIndex5Yt.push(count_Yt5);
          // this.tnglIndex6Yt = []
          for (let i = 0; i < this.MediaYtShareNew.length; i++) {       
              if (this.MediaYtShareNew[i].dateid == this.Settanggal[6]) {
                  count_Yt6 += this.MediaYtShareNew[i].Total;
              }
          }
          // this.tnglIndex6Yt.push(count_Yt6);
          // this.tnglIndex7Yt = []
          for (let i = 0; i < this.MediaYtShareNew.length; i++) {       
              if (this.MediaYtShareNew[i].dateid == this.Settanggal[7]) {
                  count_Yt7 += this.MediaYtShareNew[i].Total;
              }
          }     

     
          // line berita 
          
      this.seriessentiment[0].data.push(count_news0, count_news1, count_news2, count_news3, count_news4, count_news5, count_news6, count_news7)
      // line twet 
      this.seriessentiment[1].data.push(count_tweet0, count_tweet1, count_tweet2, count_tweet3, count_tweet4, count_tweet5, count_tweet6, count_tweet7)
      // line youtube
      this.seriessentiment[2].data.push(count_Yt0, count_Yt1, count_Yt2, count_Yt3, count_Yt4, count_Yt5, count_Yt6, count_Yt7)
      window.dispatchEvent(new Event('resize'))
        // ======================================================================================= end Grafik content per sentiment
            for (let i = 0; i < data.data.length; i++) {       
                // if (data.data[i].sentiment == 'Netral') {
                //     this.kontenBeritaNetral.push(data.data[i])
                // }
            }    

            var sentimen_categori_psitif = 0;
            var sentimen_categori_negative = 0;
            var sentimen_categori_netral = 0;
            var total_all = 0;
            for (let i = 0; i < this.chartCombinasi.length; i++) {       
                if (this.chartCombinasi[i].Positive != undefined) {
                  total_all += this.chartCombinasi[i].Positive;
                  sentimen_categori_psitif += this.chartCombinasi[i].Positive;
                }  
                if (this.chartCombinasi[i].Negative != undefined) {
                  sentimen_categori_negative += this.chartCombinasi[i].Negative;
                  total_all += this.chartCombinasi[i].Negative;
                }
                if (this.chartCombinasi[i].Netral != undefined) {
                  sentimen_categori_netral += this.chartCombinasi[i].Netral;
                  total_all += this.chartCombinasi[i].Netral;
                }
            }  
            const beritaNetralPersen = sentimen_categori_netral / total_all * 100 
            this.beritaNetralPersen = parseInt(beritaNetralPersen.toFixed(2))
            const beritaNegativePersen = sentimen_categori_negative / total_all * 100 
            this.beritaNegativePersen = parseInt(beritaNegativePersen.toFixed(2))
            const beritaPositvePersen = sentimen_categori_psitif / total_all * 100 
            this.beritaPositifPersen = parseInt(beritaPositvePersen.toFixed(2))
            

            
            this.seriess.push(sentimen_categori_netral, sentimen_categori_negative, sentimen_categori_psitif)  
        setTimeout(() => {
          this.dialog = false;
        }, 1000);                 
    } catch (e) {
      
      setTimeout(() => {
          this.dialog = false;
        }, 1000);   
      console.log('error')
      console.log(e)
      }
  },

    // ================================================================
    // ========================= end sentimen =========================
    // ================================================================

    // ================================================================
    // ========================= action click =========================
    // ================================================================
  //sentimentanalysisberita
  async loadSentimentanalysisBerita(){
    // alert('aaa');
    this.$refs.topPersonComponent.loadSentimentanalysisBerita();
      this.dialog = true
      setTimeout(() => {
        this.dialog = false;
      }, 1000);     
      try{    
      window.dispatchEvent(new Event('resize'))
      this.click = 'berita'
      if(this.click == 'berita'){

        this.seriess = []
        // this.seriess.push(this.mediaBeritaNetral.length, this.mediaBeritaNegative.length, this.mediaBeritaPositive.length)      
        this.seriess.push(this.count_chart_mediaBeritaNetral, this.count_chart_mediaBeritaNegative, this.count_chart_mediaBeritaPositive)
   
        this.chart[0].name = this.SetPerson[0]
        this.chart[0].amount = this.valueBubleIndx0Berita.length
        this.chart[1].name = this.SetPerson[1]
        this.chart[1].amount = this.valueBubleIndx1Berita.length
        this.chart[2].name = this.SetPerson[2]
        this.chart[2].amount = this.valueBubleIndx2Berita.length
        this.chart[3].name = this.SetPerson[3]
        this.chart[3].amount = this.valueBubleIndx3Berita.length
        this.chart[4].name = this.SetPerson[4]
        this.chart[4].amount = this.valueBubleIndx4Berita.length
        this.chart[5].name = this.SetPerson[5]
        this.chart[5].amount = this.valueBubleIndx5Berita.length
      this.words = [[this.SetWord[0], this.wordCloudIndx0Berita.length], [this.SetWord[1], this.wordCloudIndx1Berita.length], [this.SetWord[2], this.wordCloudIndx2Berita.length], [this.SetWord[3], this.wordCloudIndx3Berita.length], [this.SetWord[4], this.wordCloudIndx4Berita.length]]   

      if(this.isPerson == true){
        this.barchart.xaxis.categories[0] = this.SetPerson[0]
        this.barchart.xaxis.categories[1] = this.SetPerson[1]
        this.barchart.xaxis.categories[2] = this.SetPerson[2]
        this.barchart.xaxis.categories[3] = this.SetPerson[3]
        this.barchart.xaxis.categories[4] = this.SetPerson[4]
        this.barchart.xaxis.categories[5] = this.SetPerson[5]
        this.series1[0].data = [this.valueBubleIndx0Berita.length, this.valueBubleIndx1Berita.length, this.valueBubleIndx2Berita.length, this.valueBubleIndx3Berita.length,this.valueBubleIndx4Berita.length, this.valueBubleIndx5Berita.length]                    
      }                        
      
      this.kontenBeritaPositive = []
        this.kontenBeritaNegative = []
        this.kontenBeritaNetral = []
        for (let i = 0; i < this.mediaBerita.length; i++) {       
          if (this.mediaBerita[i].sentiment == 'Positive') {
              this.kontenBeritaPositive.push(this.mediaBerita[i]);
          }
      }      
        for (let i = 0; i < this.mediaBerita.length; i++) {       
          if (this.mediaBerita[i].sentiment == 'Negative') {
              this.kontenBeritaNegative.push(this.mediaBerita[i]);
          }
      }      
        for (let i = 0; i < this.mediaBerita.length; i++) {       
          if (this.mediaBerita[i].sentiment == 'Netral') {
              this.kontenBeritaNetral.push(this.mediaBerita[i]);
          }
      } 

      const beritaNetralPersen = this.kontenBeritaNetral.length / this.mediaBerita.length * 100 
      this.beritaNetralPersen = beritaNetralPersen.toFixed(2)
      const beritaNegativePersen = this.kontenBeritaNegative.length / this.mediaBerita.length * 100 
      this.beritaNegativePersen = beritaNegativePersen.toFixed(2)
      const beritaPositvePersen = this.kontenBeritaPositive.length / this.mediaBerita.length * 100 
      this.beritaPositifPersen = beritaPositvePersen.toFixed(2)      
      }
    } catch (e) {
      console.log('error')
      console.log(e)
      }
      },









    //load sentiment twet
    async loadSentimentTweet(){
      this.dialog = true
          setTimeout(() => {
          this.dialog = false;
        }, 1000);            
      try{
        window.dispatchEvent(new Event('resize'))
        this.click = 'twitter'
        if(this.click =='twitter'){      
        this.$refs.topPersonComponent.loadSentimentTweet();
        this.chart[0].name = this.SetPerson[0]
        this.chart[0].amount = this.valueBubleIndx0Twitter.length
        this.chart[1].name = this.SetPerson[1]
        this.chart[1].amount = this.valueBubleIndx1Twitter.length
        this.chart[2].name = this.SetPerson[2]
        this.chart[2].amount = this.valueBubleIndx2Twitter.length
        this.chart[3].name = this.SetPerson[3]
        this.chart[3].amount = this.valueBubleIndx3Twitter.length
        this.chart[4].name = this.SetPerson[4]
        this.chart[4].amount = this.valueBubleIndx4Twitter.length
        this.chart[5].name = this.SetPerson[5]
        this.chart[5].amount = this.valueBubleIndx5Twitter.length
        this.words = [[this.SetWord[0], this.wordCloudIndx0Twitter.length], [this.SetWord[1], this.wordCloudIndx1Twitter.length], [this.SetWord[2], this.wordCloudIndx2Twitter.length], [this.SetWord[3], this.wordCloudIndx3Twitter.length], [this.SetWord[4], this.wordCloudIndx4Twitter.length]]                                                               
        if(this.isPerson == true){
        this.barchart.xaxis.categories[0] = this.SetPerson[0]
        this.barchart.xaxis.categories[1] = this.SetPerson[1]
        this.barchart.xaxis.categories[2] = this.SetPerson[2]
        this.barchart.xaxis.categories[3] = this.SetPerson[3]
        this.barchart.xaxis.categories[4] = this.SetPerson[4]
        this.barchart.xaxis.categories[5] = this.SetPerson[5]
        this.series1[0].data = [this.valueBubleIndx0Twitter.length, this.valueBubleIndx1Twitter.length, this.valueBubleIndx2Twitter.length, this.valueBubleIndx3Twitter.length,this.valueBubleIndx4Twitter.length, this.valueBubleIndx5Twitter.length]                    
        }                      
        if(this.isOrganisasi == true){
        this.barchart.xaxis.categories[0] = this.SetOrganisasi[0]
        this.barchart.xaxis.categories[1] = this.SetOrganisasi[1]
        this.barchart.xaxis.categories[2] = this.SetOrganisasi[2]
        this.barchart.xaxis.categories[3] = this.SetOrganisasi[3]
        this.barchart.xaxis.categories[4] = this.SetOrganisasi[4]
        this.barchart.xaxis.categories[5] = this.SetOrganisasi[5]
        this.series1[0].data = [this.valueBubleIndx0OrgTwitter.length, this.valueBubleIndx1OrgTwitter.length, this.valueBubleIndx2OrgTwitter.length, this.valueBubleIndx3OrgTwitter.length, this.valueBubleIndx4OrgTwitter.length, this.valueBubleIndx5OrgTwitter.length]      
        }  
        this.seriess=[]
        // this.seriess.push(this.kontenTwitterNetral.length, this.kontenTwitterNegative.length, this.kontenTwitterPositive.length)
        this.seriess.push(this.count_chart_kontenTwitterNetral, this.count_chart_kontenTwitterNegative, this.count_chart_kontenTwitterPositive)
        // this.seriess.push(30, 40, 500)
        // alert(this.MediatwitterShare.length);
        this.kontenBeritaNetral = this.kontenTwitterNetral
        this.kontenBeritaNegative = this.kontenTwitterNegative
        this.kontenBeritaPositive = this.kontenTwitterPositive
        const beritaNetralPersen = this.kontenTwitterNetral.length / this.MediatwitterShare.length * 100 
        this.beritaNetralPersen = beritaNetralPersen.toFixed(2)
        const beritaNegativePersen = this.kontenTwitterNegative.length / this.MediatwitterShare.length * 100 
        this.beritaNegativePersen = beritaNegativePersen.toFixed(2)
        const beritaPositvePersen = this.kontenTwitterPositive.length / this.MediatwitterShare.length * 100 
        this.beritaPositifPersen = beritaPositvePersen.toFixed(2)       
        }    
      } catch (e) {
      console.log('error')
      console.log(e)
      }
    },
    //load sentiment yt
    async loadSentimentYt(){
      this.dialog = true
      setTimeout(() => {
        this.dialog = false;
      }, 1000);            
      try{
      window.dispatchEvent(new Event('resize'))
      this.click = 'youtube'
      if(this.click =='youtube'){
      this.$refs.topPersonComponent.loadSentimentYt();
      this.seriess=[]
      // this.seriess.push(this.kontenYoutubeNetral.length, this.kontenYoutubeNegative.length, this.kontenYoutubePositive.length)
      this.seriess.push(this.count_chart_kontenYoutubeNetral, this.count_chart_kontenYoutubeNegative, this.count_chart_kontenYoutubePositive)
      this.chart[0].name = this.SetPerson[0]
      this.chart[0].amount = this.valueBubleIndx0Youtube.length
      this.chart[1].name = this.SetPerson[1]
      this.chart[1].amount = this.valueBubleIndx1Youtube.length
      this.chart[2].name = this.SetPerson[2]
      this.chart[2].amount = this.valueBubleIndx2Youtube.length
      this.chart[3].name = this.SetPerson[3]
      this.chart[3].amount = this.valueBubleIndx3Youtube.length
      this.chart[4].name = this.SetPerson[4]
      this.chart[4].amount = this.valueBubleIndx4Youtube.length
      this.chart[5].name = this.SetPerson[5]
      this.chart[5].amount = this.valueBubleIndx4Youtube.length
      this.words = [[this.SetWord[0], this.wordCloudIndx0Youtube.length], [this.SetWord[1], this.wordCloudIndx1Youtube.length], [this.SetWord[2], this.wordCloudIndx2Youtube.length], [this.SetWord[3], this.wordCloudIndx3Youtube.length], [this.SetWord[4], this.wordCloudIndx4Youtube.length]]                                      
      if(this.isPerson == true){
          this.barchart.xaxis.categories[0] = this.SetPerson[0]
          this.barchart.xaxis.categories[1] = this.SetPerson[1]
          this.barchart.xaxis.categories[2] = this.SetPerson[2]
          this.barchart.xaxis.categories[3] = this.SetPerson[3]
          this.barchart.xaxis.categories[4] = this.SetPerson[4]
          this.barchart.xaxis.categories[5] = this.SetPerson[5]
          this.series1[0].data = [this.valueBubleIndx0Youtube.length, this.valueBubleIndx1Youtube.length, this.valueBubleIndx2Youtube.length,this.valueBubleIndx3Youtube.length, this.valueBubleIndx4Youtube.length,this.valueBubleIndx5Youtube.length]                    
          }                      
      if(this.isOrganisasi == true){
          this.barchart.xaxis.categories[0] = this.SetOrganisasi[0]
          this.barchart.xaxis.categories[1] = this.SetOrganisasi[1]
          this.barchart.xaxis.categories[2] = this.SetOrganisasi[2]
          this.barchart.xaxis.categories[3] = this.SetOrganisasi[3]
          this.barchart.xaxis.categories[4] = this.SetOrganisasi[4]
          this.barchart.xaxis.categories[5] = this.SetOrganisasi[5]
          this.series1[0].data = [this.valueBubleIndx0OrgYoutube.length, this.valueBubleIndx1OrgYoutube.length, this.valueBubleIndx2OrgYoutube.length, this.valueBubleIndx3OrgYoutube.length,this.valueBubleIndx4OrgYoutube.length, this.valueBubleIndx5OrgYoutube.length]
      }   
      this.kontenBeritaNetral = this.kontenYoutubeNetral
      this.kontenBeritaNegative = this.kontenYoutubeNegative
      this.kontenBeritaPositive = this.kontenYoutubePositive
      const beritaNetralPersen = this.kontenYoutubeNetral.length / this.MediaYtShare.length * 100 
      this.beritaNetralPersen = beritaNetralPersen.toFixed(2)
      const beritaNegativePersen = this.kontenYoutubeNegative.length / this.MediaYtShare.length * 100 
      this.beritaNegativePersen = beritaNegativePersen.toFixed(2)
      const beritaPositvePersen = this.kontenYoutubePositive.length / this.MediaYtShare.length * 100 
      this.beritaPositifPersen = beritaPositvePersen.toFixed(2)     
      }
    } catch (e) {
      console.log('error')
      }
    },
    // ================================================================
    // ========================= and action click =====================
    // ================================================================

    // function ?? 
    clickTopPerson(name){
        this.dialog = true
          setTimeout(() => {
        this.dialog = false;
        }, 1000);     
      try{          
       if(name == this.SetPerson[0]){
        this.click = name
         this.chart[0].color = "#f20053"        
         this.chart[1].color = "#F1E987"
         this.chart[2].color = "#B3B8F4"
         this.chart[3].color = "#5EC3C2"
         this.chart[4].color = "#AFDAF5"
         this.chart[5].color = "#C4C4C4"
          this.chart[0].stroke= '#000'        
          this.chart[1].stroke= ''        
          this.chart[2].stroke= ''        
          this.chart[3].stroke= ''        
          this.chart[4].stroke= ''        
          this.chart[5].stroke= ''                  
          this.words = [[this.SetWord[0], this.wordCloudIndx0Person0.length], [this.SetWord[1], this.wordCloudIndx1Person0.length], [this.SetWord[2], this.wordCloudIndx2Person0.length], [this.SetWord[3], this.wordCloudIndx3Person0.length], [this.SetWord[4], this.wordCloudIndx4Person0.length]]                
          window.dispatchEvent(new Event('resize'))         
      if(this.isPerson == true){
      this.barchart.xaxis.categories[0] = this.SetPerson[0]
      this.barchart.xaxis.categories[1] = this.SetPerson[1]
      this.barchart.xaxis.categories[2] = this.SetPerson[2]
      this.barchart.xaxis.categories[3] = this.SetPerson[3]
      this.barchart.xaxis.categories[4] = this.SetPerson[4]
      this.barchart.xaxis.categories[5] = this.SetPerson[5]
      this.series1[0].data = [this.valueBublePerson0Indx0.length, this.valueBublePerson0Indx1.length, this.valueBublePerson0Indx2.length, this.valueBublePerson0Indx3.length, this.valueBublePerson0Indx4.length, this.valueBublePerson0Indx5.length]                    
      }    
      if(this.isOrganisasi == true){
        console.log('organisasi')
        this.barchart.xaxis.categories[0] = this.SetOrganisasi[0]
        this.barchart.xaxis.categories[1] = this.SetOrganisasi[1]
        this.barchart.xaxis.categories[2] = this.SetOrganisasi[2]
        this.barchart.xaxis.categories[3] = this.SetOrganisasi[3]
        this.barchart.xaxis.categories[4] = this.SetOrganisasi[4]
        this.barchart.xaxis.categories[5] = this.SetOrganisasi[5]
        this.series1[0].data = [this.valueBubleOrg0Indx0.length, this.valueBubleOrg0Indx1.length, this.valueBubleOrg0Indx2.length, this.valueBubleOrg0Indx3.length, this.valueBubleOrg0Indx4.length, this.valueBubleOrg0Indx5.length]                   
      }
        this.kontenBeritaPositive =  this.valueBublePerson0Positive
        this.kontenBeritaNegative = this.valueBublePerson0Negative
        this.kontenBeritaNetral = this.valueBublePerson0Netral
        const beritaNetralPersen = this.valueBublePerson0Netral.length / this.chartBubleIndx0.length * 100 
        this.beritaNetralPersen = beritaNetralPersen.toFixed(2)
        const beritaNegativePersen = this.valueBublePerson0Negative.length / this.chartBubleIndx0.length * 100 
        this.beritaNegativePersen = beritaNegativePersen.toFixed(2)
        const beritaPositvePersen = this.valueBublePerson0Positive.length / this.chartBubleIndx0.length * 100 
        this.beritaPositifPersen = beritaPositvePersen.toFixed(2)
      }
       if(name == this.SetPerson[1]){
        this.click = name
        this.chart[0].color = "#F88FB3"      
        this.chart[1].color = "#ffe600"
         this.chart[2].color = "#B3B8F4"
         this.chart[3].color = "#5EC3C2"
         this.chart[4].color = "#AFDAF5"
         this.chart[5].color = "#C4C4C4"
          this.chart[0].stroke= ''        
          this.chart[1].stroke= '#000'        
          this.chart[2].stroke= ''        
          this.chart[3].stroke= ''        
          this.chart[4].stroke= ''        
          this.chart[5].stroke= ''         
          this.words = [[this.SetWord[0], this.wordCloudIndx0Person1.length], [this.SetWord[1], this.wordCloudIndx1Person1.length], [this.SetWord[2], this.wordCloudIndx2Person1.length], [this.SetWord[3], this.wordCloudIndx3Person1.length], [this.SetWord[4], this.wordCloudIndx4Person1.length]]                 
          window.dispatchEvent(new Event('resize'))         
      if(this.isPerson == true){
      this.barchart.xaxis.categories[0] = this.SetPerson[0]
      this.barchart.xaxis.categories[1] = this.SetPerson[1]
      this.barchart.xaxis.categories[2] = this.SetPerson[2]
      this.barchart.xaxis.categories[3] = this.SetPerson[3]
      this.barchart.xaxis.categories[4] = this.SetPerson[4]
      this.barchart.xaxis.categories[5] = this.SetPerson[5]
      this.series1[0].data = [this.valueBublePerson1Indx0.length, this.valueBublePerson1Indx1.length, this.valueBublePerson1Indx2.length, this.valueBublePerson1Indx3.length, this.valueBublePerson1Indx4.length, this.valueBublePerson1Indx5.length]                    
      }    
      if(this.isOrganisasi == true){
        console.log('organisasi')
        this.barchart.xaxis.categories[0] = this.SetOrganisasi[0]
        this.barchart.xaxis.categories[1] = this.SetOrganisasi[1]
        this.barchart.xaxis.categories[2] = this.SetOrganisasi[2]
        this.barchart.xaxis.categories[3] = this.SetOrganisasi[3]
        this.barchart.xaxis.categories[4] = this.SetOrganisasi[4]
        this.barchart.xaxis.categories[5] = this.SetOrganisasi[5]
        this.series1[0].data = [this.valueBubleOrg1Indx0.length, this.valueBubleOrg1Indx1.length, this.valueBubleOrg1Indx2.length, this.valueBubleOrg1Indx3.length, this.valueBubleOrg1Indx4.length, this.valueBubleOrg1Indx5.length]                   
      }
       this.kontenBeritaPositive =  this.valueBublePerson1Positive
        this.kontenBeritaNegative = this.valueBublePerson1Negative
        this.kontenBeritaNetral = this.valueBublePerson1Netral
        const beritaNetralPersen = this.valueBublePerson1Netral.length / this.chartBubleIndx1.length * 100 
        this.beritaNetralPersen = beritaNetralPersen.toFixed(2)
        const beritaNegativePersen = this.valueBublePerson1Negative.length / this.chartBubleIndx1.length * 100 
        this.beritaNegativePersen = beritaNegativePersen.toFixed(2)
        const beritaPositvePersen = this.valueBublePerson1Positive.length / this.chartBubleIndx1.length * 100 
        this.beritaPositifPersen = beritaPositvePersen.toFixed(2)
      }
       if(name == this.SetPerson[2]){
        this.click = name
        this.chart[0].color = "#F88FB3"
        this.chart[1].color = "#F1E987"
         this.chart[2].color = "#0022ff"
         this.chart[3].color = "#5EC3C2"
         this.chart[4].color = "#AFDAF5"
         this.chart[5].color = "#C4C4C4"
          this.chart[0].stroke= ''        
          this.chart[1].stroke= ''        
          this.chart[2].stroke= '#000'        
          this.chart[3].stroke= ''        
          this.chart[4].stroke= ''        
          this.chart[5].stroke= ''             
          this.words = [[this.SetWord[0], this.wordCloudIndx0Person2.length], [this.SetWord[1], this.wordCloudIndx1Person2.length], [this.SetWord[2], this.wordCloudIndx2Person2.length], [this.SetWord[3], this.wordCloudIndx3Person2.length], [this.SetWord[4], this.wordCloudIndx4Person2.length]]                 
          window.dispatchEvent(new Event('resize'))         
      if(this.isPerson == true){
      this.barchart.xaxis.categories[0] = this.SetPerson[0]
      this.barchart.xaxis.categories[1] = this.SetPerson[1]
      this.barchart.xaxis.categories[2] = this.SetPerson[2]
      this.barchart.xaxis.categories[3] = this.SetPerson[3]
      this.barchart.xaxis.categories[4] = this.SetPerson[4]
      this.barchart.xaxis.categories[5] = this.SetPerson[5]
      this.series1[0].data = [this.valueBublePerson2Indx0.length, this.valueBublePerson2Indx1.length, this.valueBublePerson2Indx2.length, this.valueBublePerson2Indx3.length, this.valueBublePerson2Indx4.length, this.valueBublePerson2Indx5.length]                    
      }    
      if(this.isOrganisasi == true){
        this.barchart.xaxis.categories[0] = this.SetOrganisasi[0]
        this.barchart.xaxis.categories[1] = this.SetOrganisasi[1]
        this.barchart.xaxis.categories[2] = this.SetOrganisasi[2]
        this.barchart.xaxis.categories[3] = this.SetOrganisasi[3]
        this.barchart.xaxis.categories[4] = this.SetOrganisasi[4]
        this.barchart.xaxis.categories[5] = this.SetOrganisasi[5]
        this.series1[0].data = [this.valueBubleOrg2Indx0.length, this.valueBubleOrg2Indx1.length, this.valueBubleOrg2Indx2.length, this.valueBubleOrg2Indx3.length, this.valueBubleOrg2Indx4.length, this.valueBubleOrg2Indx5.length]                   
      }
       this.kontenBeritaPositive =  this.valueBublePerson2Positive
        this.kontenBeritaNegative = this.valueBublePerson2Negative
        this.kontenBeritaNetral = this.valueBublePerson2Netral
        const beritaNetralPersen = this.valueBublePerson2Netral.length / this.chartBubleIndx2.length * 100 
        this.beritaNetralPersen = beritaNetralPersen.toFixed(2)
        const beritaNegativePersen = this.valueBublePerson2Negative.length / this.chartBubleIndx2.length * 100 
        this.beritaNegativePersen = beritaNegativePersen.toFixed(2)
        const beritaPositvePersen = this.valueBublePerson2Positive.length / this.chartBubleIndx2.length * 100 
        this.beritaPositifPersen = beritaPositvePersen.toFixed(2)
       }
       if(name == this.SetPerson[3]){
        this.click = name
        this.chart[0].color = "#F88FB3"
        this.chart[1].color = "#F1E987"
         this.chart[2].color = "#B3B8F4"
         this.chart[3].color = "#00fffc"
         this.chart[4].color = "#AFDAF5"
         this.chart[5].color = "#C4C4C4"
          this.chart[0].stroke= ''        
          this.chart[1].stroke= ''        
          this.chart[2].stroke= ''        
          this.chart[3].stroke= '#000'        
          this.chart[4].stroke= ''        
          this.chart[5].stroke= ''        
          this.words = [[this.SetWord[0], this.wordCloudIndx0Person3.length], [this.SetWord[1], this.wordCloudIndx1Person3.length], [this.SetWord[2], this.wordCloudIndx2Person3.length], [this.SetWord[3], this.wordCloudIndx3Person3.length], [this.SetWord[4], this.wordCloudIndx4Person3.length]]                 
          window.dispatchEvent(new Event('resize'))         
      if(this.isPerson == true){
      this.barchart.xaxis.categories[0] = this.SetPerson[0]
      this.barchart.xaxis.categories[1] = this.SetPerson[1]
      this.barchart.xaxis.categories[2] = this.SetPerson[2]
      this.barchart.xaxis.categories[3] = this.SetPerson[3]
      this.barchart.xaxis.categories[4] = this.SetPerson[4]
      this.barchart.xaxis.categories[5] = this.SetPerson[5]
      this.series1[0].data = [this.valueBublePerson3Indx0.length, this.valueBublePerson3Indx1.length, this.valueBublePerson3Indx2.length, this.valueBublePerson3Indx3.length, this.valueBublePerson3Indx4.length, this.valueBublePerson3Indx5.length]                    
      }    
      if(this.isOrganisasi == true){
        this.barchart.xaxis.categories[0] = this.SetOrganisasi[0]
        this.barchart.xaxis.categories[1] = this.SetOrganisasi[1]
        this.barchart.xaxis.categories[2] = this.SetOrganisasi[2]
        this.barchart.xaxis.categories[3] = this.SetOrganisasi[3]
        this.barchart.xaxis.categories[4] = this.SetOrganisasi[4]
        this.barchart.xaxis.categories[5] = this.SetOrganisasi[5]
        this.series1[0].data = [this.valueBubleOrg3Indx0.length, this.valueBubleOrg3Indx1.length, this.valueBubleOrg3Indx2.length, this.valueBubleOrg3Indx3.length, this.valueBubleOrg3Indx4.length, this.valueBubleOrg3Indx5.length]                   
      }
       this.kontenBeritaPositive =  this.valueBublePerson3Positive
        this.kontenBeritaNegative = this.valueBublePerson3Negative
        this.kontenBeritaNetral = this.valueBublePerson3Netral
        const beritaNetralPersen = this.valueBublePerson3Netral.length / this.chartBubleIndx3.length * 100 
        this.beritaNetralPersen = beritaNetralPersen.toFixed(2)
        const beritaNegativePersen = this.valueBublePerson3Negative.length / this.chartBubleIndx3.length * 100 
        this.beritaNegativePersen = beritaNegativePersen.toFixed(2)
        const beritaPositvePersen = this.valueBublePerson3Positive.length / this.chartBubleIndx3.length * 100 
        this.beritaPositifPersen = beritaPositvePersen.toFixed(2)
       }
       if(name == this.SetPerson[4]){
        this.click = name
        this.chart[0].color = "#F88FB3"
        this.chart[1].color = "#F1E987"
         this.chart[2].color = "#B3B8F4"
         this.chart[3].color = "#5EC3C2"
         this.chart[4].color = "#009dff"
         this.chart[5].color = "#C4C4C4"
          this.chart[0].stroke= ''        
          this.chart[1].stroke= ''        
          this.chart[2].stroke= ''        
          this.chart[3].stroke= ''        
          this.chart[4].stroke= '#000'        
          this.chart[5].stroke= ''        
          this.words = [[this.SetWord[0], this.wordCloudIndx0Person4.length], [this.SetWord[1], this.wordCloudIndx1Person4.length], [this.SetWord[2], this.wordCloudIndx2Person4.length], [this.SetWord[3], this.wordCloudIndx3Person4.length], [this.SetWord[4], this.wordCloudIndx4Person4.length]]                 
          window.dispatchEvent(new Event('resize'))         
      if(this.isPerson == true){
      this.barchart.xaxis.categories[0] = this.SetPerson[0]
      this.barchart.xaxis.categories[1] = this.SetPerson[1]
      this.barchart.xaxis.categories[2] = this.SetPerson[2]
      this.barchart.xaxis.categories[3] = this.SetPerson[3]
      this.barchart.xaxis.categories[4] = this.SetPerson[4]
      this.barchart.xaxis.categories[5] = this.SetPerson[5]
      this.series1[0].data = [this.valueBublePerson4Indx0.length, this.valueBublePerson4Indx1.length, this.valueBublePerson4Indx2.length, this.valueBublePerson4Indx3.length, this.valueBublePerson4Indx4.length, this.valueBublePerson4Indx5.length]                    
      }    
      if(this.isOrganisasi == true){
        this.barchart.xaxis.categories[0] = this.SetOrganisasi[0]
        this.barchart.xaxis.categories[1] = this.SetOrganisasi[1]
        this.barchart.xaxis.categories[2] = this.SetOrganisasi[2]
        this.barchart.xaxis.categories[3] = this.SetOrganisasi[3]
        this.barchart.xaxis.categories[4] = this.SetOrganisasi[4]
        this.barchart.xaxis.categories[5] = this.SetOrganisasi[5]
        this.series1[0].data = [this.valueBubleOrg4Indx0.length, this.valueBubleOrg4Indx1.length, this.valueBubleOrg4Indx2.length, this.valueBubleOrg4Indx3.length, this.valueBubleOrg4Indx4.length, this.valueBubleOrg4Indx5.length]                   
      }
       this.kontenBeritaPositive =  this.valueBublePerson4Positive
        this.kontenBeritaNegative = this.valueBublePerson4Negative
        this.kontenBeritaNetral = this.valueBublePerson4Netral
        const beritaNetralPersen = this.valueBublePerson4Netral.length / this.chartBubleIndx4.length * 100 
        this.beritaNetralPersen = beritaNetralPersen.toFixed(2)
        const beritaNegativePersen = this.valueBublePerson4Negative.length / this.chartBubleIndx4.length * 100 
        this.beritaNegativePersen = beritaNegativePersen.toFixed(2)
        const beritaPositvePersen = this.valueBublePerson4Positive.length / this.chartBubleIndx4.length * 100 
        this.beritaPositifPersen = beritaPositvePersen.toFixed(2)
       }
       if(name == this.SetPerson[5]){
        this.click = name
        this.chart[0].color = "#F88FB3"
         this.chart[1].color = "#F1E987"
         this.chart[2].color = "#B3B8F4"
         this.chart[3].color = "#5EC3C2"
         this.chart[4].color = "#AFDAF5"
         this.chart[5].color = "#454545"
          this.chart[0].stroke= ''        
          this.chart[1].stroke= ''        
          this.chart[2].stroke= ''        
          this.chart[3].stroke= ''        
          this.chart[4].stroke= ''        
          this.chart[5].stroke= '#000'        
          this.words = [[this.SetWord[0], this.wordCloudIndx0Person5.length], [this.SetWord[1], this.wordCloudIndx1Person5.length], [this.SetWord[2], this.wordCloudIndx2Person5.length], [this.SetWord[3], this.wordCloudIndx3Person5.length], [this.SetWord[4], this.wordCloudIndx4Person5.length]]                 
          window.dispatchEvent(new Event('resize'))         
      if(this.isPerson == true){
      this.barchart.xaxis.categories[0] = this.SetPerson[0]
      this.barchart.xaxis.categories[1] = this.SetPerson[1]
      this.barchart.xaxis.categories[2] = this.SetPerson[2]
      this.barchart.xaxis.categories[3] = this.SetPerson[3]
      this.barchart.xaxis.categories[4] = this.SetPerson[4]
      this.barchart.xaxis.categories[5] = this.SetPerson[5]
      this.series1[0].data = [this.valueBublePerson5Indx0.length, this.valueBublePerson5Indx1.length, this.valueBublePerson5Indx2.length, this.valueBublePerson5Indx3.length, this.valueBublePerson5Indx4.length, this.valueBublePerson5Indx5.length]                    
      }    
      if(this.isOrganisasi == true){
        this.barchart.xaxis.categories[0] = this.SetOrganisasi[0]
        this.barchart.xaxis.categories[1] = this.SetOrganisasi[1]
        this.barchart.xaxis.categories[2] = this.SetOrganisasi[2]
        this.barchart.xaxis.categories[3] = this.SetOrganisasi[3]
        this.barchart.xaxis.categories[4] = this.SetOrganisasi[4]
        this.barchart.xaxis.categories[5] = this.SetOrganisasi[5]
        this.series1[0].data = [this.valueBubleOrg5Indx0.length, this.valueBubleOrg5Indx1.length, this.valueBubleOrg5Indx2.length, this.valueBubleOrg5Indx3.length, this.valueBubleOrg5Indx4.length, this.valueBubleOrg5Indx5.length]                   
      }
       this.kontenBeritaPositive =  this.valueBublePerson5Positive
        this.kontenBeritaNegative = this.valueBublePerson5Negative
        this.kontenBeritaNetral = this.valueBublePerson5Netral
        const beritaNetralPersen = this.valueBublePerson5Netral.length / this.chartBubleIndx5.length * 100 
        this.beritaNetralPersen = beritaNetralPersen.toFixed(2)
        const beritaNegativePersen = this.valueBublePerson5Negative.length / this.chartBubleIndx5.length * 100 
        this.beritaNegativePersen = beritaNegativePersen.toFixed(2)
        const beritaPositvePersen = this.valueBublePerson5Positive.length / this.chartBubleIndx5.length * 100 
        this.beritaPositifPersen = beritaPositvePersen.toFixed(2)
       }
      }      
      catch(e){
        console.log("error")
        console.log(e)
      }
     },  
    
    //  finction ??
   clickChartBar(event, chartContext,config) { 
      this.dialog = true
          setTimeout(() => {
        this.dialog = false;
        }, 1000);       
     if(config.dataPointIndex == 0){ 
       if(this.click == ""){
          this.kontenBeritaPositive =  this.valueBublePerson0Positive
          this.kontenBeritaNegative = this.valueBublePerson0Negative
          this.kontenBeritaNetral = this.valueBublePerson0Netral
          const beritaNetralPersen = this.valueBublePerson0Netral.length / this.chartBubleIndx0.length * 100 
          this.beritaNetralPersen = beritaNetralPersen.toFixed(2)
          const beritaNegativePersen = this.valueBublePerson0Negative.length / this.chartBubleIndx0.length * 100 
          this.beritaNegativePersen = beritaNegativePersen.toFixed(2)
          const beritaPositvePersen = this.valueBublePerson0Positive.length / this.chartBubleIndx0.length * 100 
          this.beritaPositifPersen = beritaPositvePersen.toFixed(2)
       }
       if(this.click == "organisasi"){      
          this.kontenBeritaPositive =  this.valueBubleOrg0Positive
          this.kontenBeritaNegative = this.valueBubleOrg0Negative
          this.kontenBeritaNetral = this.valueBubleOrg0Netral
          const beritaNetralPersen = this.valueBubleOrg0Netral.length / this.chartBubleIndx0.length * 100 
          this.beritaNetralPersen = beritaNetralPersen.toFixed(2)
          const beritaNegativePersen = this.valueBubleOrg0Negative.length / this.chartBubleIndx0.length * 100 
          this.beritaNegativePersen = beritaNegativePersen.toFixed(2)
          const beritaPositvePersen = this.valueBubleOrg0Positive.length / this.chartBubleIndx0.length * 100 
          this.beritaPositifPersen = beritaPositvePersen.toFixed(2)
       }
     } 
    if(config.dataPointIndex == 1){ 
       if(this.click == ""){
          this.kontenBeritaPositive =  this.valueBublePerson1Positive
          this.kontenBeritaNegative = this.valueBublePerson1Negative
          this.kontenBeritaNetral = this.valueBublePerson1Netral
          const beritaNetralPersen = this.valueBublePerson1Netral.length / this.chartBubleIndx1.length * 100 
          this.beritaNetralPersen = beritaNetralPersen.toFixed(2)
          const beritaNegativePersen = this.valueBublePerson1Negative.length / this.chartBubleIndx1.length * 100 
          this.beritaNegativePersen = beritaNegativePersen.toFixed(2)
          const beritaPositvePersen = this.valueBublePerson1Positive.length / this.chartBubleIndx1.length * 100 
          this.beritaPositifPersen = beritaPositvePersen.toFixed(2)
       }
       if(this.click == "organisasi"){      
          this.kontenBeritaPositive =  this.valueBubleOrg1Positive
          this.kontenBeritaNegative = this.valueBubleOrg1Negative
          this.kontenBeritaNetral = this.valueBubleOrg1Netral
          const beritaNetralPersen = this.valueBubleOrg1Netral.length / this.chartBubleIndx1Org.length * 100 
          this.beritaNetralPersen = beritaNetralPersen.toFixed(2)
          const beritaNegativePersen = this.valueBubleOrg1Negative.length / this.chartBubleIndx1Org.length * 100 
          this.beritaNegativePersen = beritaNegativePersen.toFixed(2)
          const beritaPositvePersen = this.valueBubleOrg1Positive.length / this.chartBubleIndx1Org.length * 100 
          this.beritaPositifPersen = beritaPositvePersen.toFixed(2)
       }
     } 
      if(config.dataPointIndex == 2){
        if(this.click == ""){
          this.kontenBeritaPositive =  this.valueBublePerson2Positive
          this.kontenBeritaNegative = this.valueBublePerson2Negative
          this.kontenBeritaNetral = this.valueBublePerson2Netral
          const beritaNetralPersen = this.valueBublePerson2Netral.length / this.chartBubleIndx2.length * 100 
          this.beritaNetralPersen = beritaNetralPersen.toFixed(2)
          const beritaNegativePersen = this.valueBublePerson2Negative.length / this.chartBubleIndx2.length * 100 
          this.beritaNegativePersen = beritaNegativePersen.toFixed(2)
          const beritaPositvePersen = this.valueBublePerson2Positive.length / this.chartBubleIndx2.length * 100 
          this.beritaPositifPersen = beritaPositvePersen.toFixed(2)
       }
       if(this.click == "organisasi"){      
          this.kontenBeritaPositive =  this.valueBubleOrg2Positive
          this.kontenBeritaNegative = this.valueBubleOrg2Negative
          this.kontenBeritaNetral = this.valueBubleOrg2Netral
          const beritaNetralPersen = this.valueBubleOrg2Netral.length / this.chartBubleIndx2Org.length * 100 
          this.beritaNetralPersen = beritaNetralPersen.toFixed(2)
          const beritaNegativePersen = this.valueBubleOrg2Negative.length / this.chartBubleIndx2Org.length * 100 
          this.beritaNegativePersen = beritaNegativePersen.toFixed(2)
          const beritaPositvePersen = this.valueBubleOrg2Positive.length / this.chartBubleIndx2Org.length * 100 
          this.beritaPositifPersen = beritaPositvePersen.toFixed(2)
       }
     }   
      if(config.dataPointIndex == 3){
         if(this.click == ""){
          this.kontenBeritaPositive =  this.valueBublePerson3Positive
          this.kontenBeritaNegative = this.valueBublePerson3Negative
          this.kontenBeritaNetral = this.valueBublePerson3Netral
          const beritaNetralPersen = this.valueBublePerson3Netral.length / this.chartBubleIndx3.length * 100 
          this.beritaNetralPersen = beritaNetralPersen.toFixed(2)
          const beritaNegativePersen = this.valueBublePerson3Negative.length / this.chartBubleIndx3.length * 100 
          this.beritaNegativePersen = beritaNegativePersen.toFixed(2)
          const beritaPositvePersen = this.valueBublePerson3Positive.length / this.chartBubleIndx3.length * 100 
          this.beritaPositifPersen = beritaPositvePersen.toFixed(2)
       }
       if(this.click == "organisasi"){      
          this.kontenBeritaPositive =  this.valueBubleOrg3Positive
          this.kontenBeritaNegative = this.valueBubleOrg3Negative
          this.kontenBeritaNetral = this.valueBubleOrg3Netral
          const beritaNetralPersen = this.valueBubleOrg3Netral.length / this.chartBubleIndx3Org.length * 100 
          this.beritaNetralPersen = beritaNetralPersen.toFixed(2)
          const beritaNegativePersen = this.valueBubleOrg3Negative.length / this.chartBubleIndx3Org.length * 100 
          this.beritaNegativePersen = beritaNegativePersen.toFixed(2)
          const beritaPositvePersen = this.valueBubleOrg3Positive.length / this.chartBubleIndx3Org.length * 100 
          this.beritaPositifPersen = beritaPositvePersen.toFixed(2)
       }
     } 
      if(config.dataPointIndex == 4){
         if(this.click == ""){
          this.kontenBeritaPositive =  this.valueBublePerson4Positive
          this.kontenBeritaNegative = this.valueBublePerson4Negative
          this.kontenBeritaNetral = this.valueBublePerson4Netral
          const beritaNetralPersen = this.valueBublePerson4Netral.length / this.chartBubleIndx4.length * 100 
          this.beritaNetralPersen = beritaNetralPersen.toFixed(2)
          const beritaNegativePersen = this.valueBublePerson4Negative.length / this.chartBubleIndx4.length * 100 
          this.beritaNegativePersen = beritaNegativePersen.toFixed(2)
          const beritaPositvePersen = this.valueBublePerson4Positive.length / this.chartBubleIndx4.length * 100 
          this.beritaPositifPersen = beritaPositvePersen.toFixed(2)
       }
       if(this.click == "organisasi"){      
          this.kontenBeritaPositive =  this.valueBubleOrg4Positive
          this.kontenBeritaNegative = this.valueBubleOrg4Negative
          this.kontenBeritaNetral = this.valueBubleOrg4Netral
          const beritaNetralPersen = this.valueBubleOrg4Netral.length / this.chartBubleIndx4Org.length * 100 
          this.beritaNetralPersen = beritaNetralPersen.toFixed(2)
          const beritaNegativePersen = this.valueBubleOrg4Negative.length / this.chartBubleIndx4Org.length * 100 
          this.beritaNegativePersen = beritaNegativePersen.toFixed(2)
          const beritaPositvePersen = this.valueBubleOrg4Positive.length / this.chartBubleIndx4Org.length * 100 
          this.beritaPositifPersen = beritaPositvePersen.toFixed(2)
       }
     } 
     if(config.dataPointIndex == 5){
         if(this.click == ""){
          this.kontenBeritaPositive =  this.valueBublePerson5Positive
          this.kontenBeritaNegative = this.valueBublePerson5Negative
          this.kontenBeritaNetral = this.valueBublePerson5Netral
          const beritaNetralPersen = this.valueBublePerson5Netral.length / this.chartBubleIndx5.length * 100 
          this.beritaNetralPersen = beritaNetralPersen.toFixed(2)
          const beritaNegativePersen = this.valueBublePerson5Negative.length / this.chartBubleIndx5.length * 100 
          this.beritaNegativePersen = beritaNegativePersen.toFixed(2)
          const beritaPositvePersen = this.valueBublePerson5Positive.length / this.chartBubleIndx5.length * 100 
          this.beritaPositifPersen = beritaPositvePersen.toFixed(2)
       }
       if(this.click == "organisasi"){      
          this.kontenBeritaPositive =  this.valueBubleOrg5Positive
          this.kontenBeritaNegative = this.valueBubleOrg5Negative
          this.kontenBeritaNetral = this.valueBubleOrg5Netral
          const beritaNetralPersen = this.valueBubleOrg5Netral.length / this.chartBubleIndx5Org.length * 100 
          this.beritaNetralPersen = beritaNetralPersen.toFixed(2)
          const beritaNegativePersen = this.valueBubleOrg5Negative.length / this.chartBubleIndx5Org.length * 100 
          this.beritaNegativePersen = beritaNegativePersen.toFixed(2)
          const beritaPositvePersen = this.valueBubleOrg5Positive.length / this.chartBubleIndx5Org.length * 100 
          this.beritaPositifPersen = beritaPositvePersen.toFixed(2)
       }
     }                          
   },  


      async loadSentimentanalysisBeritaOrganisasi(){
        this.dialog = true
        setTimeout(() => {
          this.dialog = false;
        }, 1000); 
        this.click = 'organisasi'
           if(this.click == 'organisasi'){       
               if(this.isOrganisasi == true){
                 this.barchart.xaxis.categories[0] = this.SetOrganisasi[0]
                 this.barchart.xaxis.categories[1] = this.SetOrganisasi[1]
                 this.barchart.xaxis.categories[2] = this.SetOrganisasi[2]
                 this.barchart.xaxis.categories[3] = this.SetOrganisasi[3]
                 this.barchart.xaxis.categories[4] = this.SetOrganisasi[4]
                 this.barchart.xaxis.categories[5] = this.SetOrganisasi[5]
                 this.series1[0].data = [this.chartBubleIndx0Org.length, this.chartBubleIndx1Org.length, this.chartBubleIndx2Org.length, this.chartBubleIndx3Org.length,this.chartBubleIndx4Org.length, this.chartBubleIndx5Org.length]
               }
             this.seriess = []    
       this.seriess.push(this.kontenBeritaNetral.length, this.kontenBeritaNegative.length, this.kontenBeritaPositive.length)             
        window.dispatchEvent(new Event('resize'))       
      }
      },
      async loadSentimentanalysisBeritaPerson(){
        this.dialog = true
        setTimeout(() => {
          this.dialog = false;
        }, 1000); 
        this.click = ''
           if(this.click == ''){       
               if(this.isPerson == true){
                 this.barchart.xaxis.categories[0] = this.SetPerson[0]
                 this.barchart.xaxis.categories[1] = this.SetPerson[1]
                 this.barchart.xaxis.categories[2] = this.SetPerson[2]
                 this.barchart.xaxis.categories[3] = this.SetPerson[3]
                 this.barchart.xaxis.categories[4] = this.SetPerson[4]
                 this.barchart.xaxis.categories[5] = this.SetPerson[5]
               this.series1[0].data = [this.chartBubleIndx0.length, this.chartBubleIndx1.length, this.chartBubleIndx2.length, this.chartBubleIndx3.length, this.chartBubleIndx4.length, this.chartBubleIndx5.length]
               }          
               this.seriess = []    
       this.seriess.push(this.kontenBeritaNetral.length, this.kontenBeritaNegative.length, this.kontenBeritaPositive.length)             
        window.dispatchEvent(new Event('resize'))      
      }
      },           
    generateData(baseval, count, yrange) {
      var i = 0;
      var series = [];
      while (i < count) {
        var x = Math.floor(Math.random() * (750 - 1 + 1)) + 1;
        var y = Math.floor(Math.random() * (yrange.max - yrange.min + 1)) + yrange.min;
        var z = Math.floor(Math.random() * (75 - 15 + 1)) + 15;
        series.push([x, y, z]);
        baseval += 86400000;
        i++;
      }
      return series;
    }
  }
}
</script>

<style> 
/*05/01 tambahkan style tab*/
.tab{
  font-size: 12px; 
}
/*note css jangan diubah*/
.v-sheet--offset {
  top: -24px;
  position: relative;
}
#app{
  background-color: #f7f6f4;
}
.apexcharts-toolbar {
  z-index: 0;
}
.tooltip .tooltip-inner{
  max-width: 100px !important;
  width: 100px !important;
}
.v-tooltip__content {
  font-size: 9px !important;
  max-width: 100px;
}
.row-pointer{
  cursor: pointer;
}
.overflow-card {
  overflow-y: scroll;
  overflow-x: hidden;
}

::-webkit-scrollbar{width:9px; }
::-webkit-scrollbar-thumb{width:9px; border-left:1px; background-color:#c4c4c4; border-radius: 100px;}
svg {
  display: block;
  margin: 0 auto;
}
.chart {
  transition: transform 0.7s ease-in-out;
  text-anchor: middle;
  cursor: pointer;
}
.chart__circle {
  transition: r .3s ease-in-out;
}
.chart__label {
  font-size: 14px;
  fill: #fff;
  font-weight: bold;
  text-shadow: 0 2px 10px rgba(0, 0, 0, 0.2);
}
</style>
